// import React, { useEffect, useState } from "react";
// import { useParams, Link, useNavigate } from "react-router-dom";
// import { get, post, put } from "../../../lib/http";
// import { API } from "../../../config/api";
// import { FaPlus, FaTrash, FaSpinner, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

// // Helper: Format date for input (YYYY-MM-DDTHH:MM)
// function formatDateTimeForInput(value) {
//   if (!value) return "";
//   const d = value instanceof Date ? value : new Date(value);
//   if (isNaN(d)) return "";
//   return d.toISOString().slice(0, 16);
// }

// const toDTLocal = (d) => {
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
// };

// export default function AdminEventEdit() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     name: "",
//     category: "Music",
//     description: "",
//     venue: {
//       name: "",
//       address: "",
//       city: "",
//       state: "",
//       country: "",
//       pincode: "",
//       latitude: "",
//       longitude: "",
//       capacity: "",
//       logoUrl: ""
//     },
//     date: "",
//     ticketCategories: [
//       { type: "", price: "", currency: "INR", totalSeats: "", availableSeats: "", perks: [""] },
//     ],
//     showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//     imageUrl: "",
//     landsacpImage: [''],
//     status: "Upcoming",
//     organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
//     termsAndConditions: [{ point: "" }],
//     ratings: { averageRating: 0, totalReviews: 0 },
//     isVerified: false,
//     isBookingOpen:true,
//     isActived: true,
//     remark: "",
//     tags: [""],
//     sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//     ageRestriction: "",
//     language: "",
//     duration: "",
//   });
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState("");
//   const [uploadProgress, setUploadProgress] = useState({});

//   const now = new Date();
//   const startOfTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
//   const minEventDate = toDTLocal(startOfTomorrow);

//   // Fetch event data
//   useEffect(() => {
//     let isMounted = true;
//     const fetchEvent = async () => {
//       try {
//         setLoading(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(`${API.events.getSinglEvent}/${id}`, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (isMounted) {
//           setForm({
//             name: res.event.name || "",
//             category: res.event.category || "Music",
//             description: res.event.description || "",
//             venue: {
//               name: res.event.venue?.name || "",
//               address: res.event.venue?.address || "",
//               city: res.event.venue?.city || "",
//               state: res.event.venue?.state || "",
//               country: res.event.venue?.country || "",
//               pincode: res.event.venue?.pincode || "",
//               latitude: res.event.venue?.latitude || "",
//               longitude: res.event.venue?.longitude || "",
//               capacity: res.event.venue?.capacity || "",
//               logoUrl: res.event.venue?.logoUrl || "",
//             },
//             date: formatDateTimeForInput(res.event.date) || "",
//             ticketCategories:
//               res.event.ticketCategories?.length > 0
//                 ? res.event.ticketCategories
//                 : [{ type: "", price: "", currency: "INR", totalSeats: "", availableSeats: "", perks: [""] }],
//             showtimes:
//               res.event.showtimes?.length > 0
//                 ? res.event.showtimes.map((s) => ({
//                   startTime: formatDateTimeForInput(s.startTime),
//                   endTime: formatDateTimeForInput(s.endTime),
//                   availableSeats: s.availableSeats || "",
//                   ticketPrice: s.ticketPrice || "",
//                 }))
//                 : [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//             imageUrl: res.event.imageUrl || "",
//             landsacpImage: res.event.landsacpImage?.length > 0 ? res.event.landsacpImage : [""],
//             status: res.event.status || "Upcoming",
//             organizer: {
//               name: res.event.organizer?.name || "",
//               contactEmail: res.event.organizer?.contactEmail || "",
//               contactPhone: res.event.organizer?.contactPhone || "",
//               website: res.event.organizer?.website || "",
//               logoUrl: res.event.organizer?.logoUrl || "",
//             },
//             termsAndConditions:
//               res.event.termsAndConditions?.length > 0
//                 ? res.event.termsAndConditions
//                 : [{ point: "" }],
//             ratings: {
//               averageRating: res.event.ratings?.averageRating || 0,
//               totalReviews: res.event.ratings?.totalReviews || 0,
//             },
//             isVerified: res.event.isVerified || false,
//             isBookingOpen:res.event.isBookingOpen || false,
//             isActived: res.event.isActived || true,
//             remark: res.event.remark || "",
//             tags: res.event.tags?.length > 0 ? res.event.tags : [""],
//             sponsors:
//               res.event.sponsors?.length > 0
//                 ? res.event.sponsors
//                 : [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//             ageRestriction: res.event.ageRestriction || "",
//             language: res.event.language || "",
//             duration: res.event.duration || "",
//           });
//         }
//       } catch (err) {
//         if (isMounted) setMessage("❌ Failed to load event details.e");
//       } finally {
//         if (isMounted) setLoading(false);
//       }
//     };
//     fetchEvent();
//     return () => {
//       isMounted = false;
//     };
//   }, [id]);

//   const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
//   const onNestedChange = (parent, key, value) =>
//     setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));
//   const onArrayChange = (arrKey, index, key, value) => {
//     const updated = [...form[arrKey]];
//     updated[index][key] = value;
//     setForm((f) => ({ ...f, [arrKey]: updated }));
//   };


//   const addArrayItem = (arrKey, newItem) =>
//     setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
//   const removeArrayItem = (arrKey, index) =>
//     setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

//   const uploadFileAndGetUrl = async (file, key = null) => {
//     if (!file) return "";
//     const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//     const fd = new FormData();
//     fd.append("file", file);
//     setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 0 }));
//     const resp = await post(API.events.fileUploader, fd, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     // const resp = await fetch(`${API.events.fileUploader}`, {
//     //   method: "POST",
//     //   headers: { Authorization: `Bearer ${token}` },
//     //   body: fd,
//     // });

//     // const data = await resp.json().catch(() => ({}));
//     setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 100 }));

//     if (!resp.success) {
//       throw new Error(resp?.message || "Upload failed");
//     }

//     const url =
//       resp?.url ||
//       resp?.resp?.url ||
//       resp?.fileUrl ||
//       resp?.location ||
//       resp?.path ||
//       resp?.secure_url ||
//       "";
//     if (!url) throw new Error("Upload success but no URL found in response.");
//     return url;
//   };

//   const handlePosterFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading poster...");
//       const url = await uploadFileAndGetUrl(file, "poster");
//       onChange("imageUrl", url);
//       setMessage("✅ Poster uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Poster upload failed.");
//     }
//   };

//   const handleLandscapeFile = async (e, index) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage(`Uploading landscape image ${index + 1}...`);
//       const url = await uploadFileAndGetUrl(file, `landscape-${index}`);
//       const imgs = [...form.landsacpImage];
//       imgs[index] = url;
//       onChange("landsacpImage", imgs);
//       setMessage("✅ Landscape image uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Landscape upload failed.");
//     }
//   };

//   const handleSponsorLogoFile = async (e, index) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage(`Uploading sponsor ${index + 1} logo...`);
//       const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
//       onArrayChange("sponsors", index, "logo", url);
//       setMessage("✅ Sponsor logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Sponsor logo upload failed.");
//     }
//   };

//   const handleOrganizerLogoFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading organizer logo...");
//       const url = await uploadFileAndGetUrl(file, "organizer");
//       onNestedChange("organizer", "logoUrl", url);
//       setMessage("✅ Organizer logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Organizer logo upload failed.");
//     }
//   };

//   const handleVenueLogoFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading venue logo...");
//       const url = await uploadFileAndGetUrl(file, "venue");
//       onNestedChange("venue", "logoUrl", url);
//       setMessage("✅ Venue logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Venue logo upload failed.");
//     }
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage("");
//     try {
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const res = await put(`${API.events.editEvent}/${id}`, form, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "application/json",
//         },
//       });
//       setMessage("✅ Event updated successfully!");
//       setTimeout(() => navigate("/admin/events"), 2000);
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Failed to update event.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="max-w-4xl mx-auto p-6">
//         <div className="bg-white shadow-lg rounded-lg p-6 animate-pulse">
//           <div className="h-8 w-1/3 bg-gray-200 rounded-lg mb-6" />
//           <div className="space-y-4">
//             <div className="h-6 w-1/2 bg-gray-200 rounded-lg" />
//             <div className="h-6 w-3/4 bg-gray-200 rounded-lg" />
//             <div className="h-6 w-1/4 bg-gray-200 rounded-lg" />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <form
//       onSubmit={onSubmit}
//       className="max-w-4xl mx-auto p-6 bg-gray-100 rounded-lg shadow-lg space-y-6"
//     >
//       <div className="flex justify-between items-center">
//         <h1 className="text-2xl font-bold text-gray-800">Edit Event</h1>
//         <Link
//           to={`/admin/events/view/${id}`}
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//         >
//           <FaPlus /> Back to View
//         </Link>
//       </div>

//       {message && (
//         <div className="flex items-center gap-2 text-sm">
//           {message.includes("✅") ? (
//             <FaCheckCircle className="text-green-500" />
//           ) : (
//             <FaTimesCircle className="text-red-500" />
//           )}
//           {message}
//         </div>
//       )}

//       {/* Basic Info */}
//       <Section title="Basic Info">
//         <Input
//           label="Event Name"
//           value={form.name}
//           onChange={(v) => onChange("name", v)}
//           required
//         />
//         <Select
//           label="Category"
//           value={form.category}
//           options={[
//             "Music",
//             "Theatre",
//             "Comedy",
//             "Dance",
//             "Sports",
//             "Exhibition",
//             "Festival",
//             "Conference",
//             "Workshop",
//             "Other",
//           ]}
//           onChange={(v) => onChange("category", v)}
//         />
//         <Textarea
//           label="Description"
//           value={form.description}
//           onChange={(v) => onChange("description", v)}
//           rows={4}
//         />

//         <Input
//           label="Event Date"
//           type="datetime-local"
//           value={form.date}
//           onChange={(v) => {
//             const picked = new Date(v);
//             if (picked < startOfTomorrow) {
//               // वैकल्पिक: user feedback
//               setMessage("❌ Event Date must be after today.");
//               return;
//             }
//             onChange("date", v);
//           }}
//           required
//           min={minEventDate}   // ⬅️ यहीं से आज और पुरानी तारीख select नहीं होगी
//         />
//       </Section>

//       <Section title="Venue">
//         <div className={AD.formGrid2}>
//           {Object.keys(form.venue).filter(k => k !== "logoUrl").map((k) => (
//             <Input
//               key={k}
//               label={k.charAt(0).toUpperCase() + k.slice(1)}
//               value={form.venue[k]}
//               onChange={(v) => onNestedChange("venue", k, v)}
//               type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
//             />
//           ))}
//         </div>

//         {/* ✅ Venue Logo */}
//         <div className="mt-4">
//           <label className="block font-medium text-gray-700">Venue Logo</label>
//           <div className="flex flex-col md:flex-row gap-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//               placeholder="Paste venue logo URL (optional)"
//               value={form.venue.logoUrl}
//               onChange={(e) => onNestedChange("venue", "logoUrl", e.target.value)}
//             />
//             <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center">
//               <input
//                 type="file"
//                 accept="image/*"
//                 className="hidden"
//                 id="venue-logo-upload"
//                 onChange={handleVenueLogoFile}
//               />
//               <label htmlFor="venue-logo-upload" className="cursor-pointer text-blue-500 hover:text-blue-700">
//                 {uploadProgress["venue"] ? (
//                   <FaSpinner className="animate-spin inline-block mr-2" />
//                 ) : (
//                   "Choose or drag logo"
//                 )}
//               </label>
//             </div>
//           </div>
//           {form.venue.logoUrl && (
//             <div className="mt-2 flex items-center gap-3">
//               <img src={form.venue.logoUrl} alt="Venue Logo" className="h-16 w-16 object-cover rounded" />
//               <p className="text-sm text-gray-600 break-all">{form.venue.logoUrl}</p>
//             </div>
//           )}
//         </div>
//       </Section>

//       {/* Ticket Categories */}
//       <Section title="Ticket Categories">
//         {form.ticketCategories.map((t, i) => (
//           <div
//             key={i}
//             className="border p-4 my-2 rounded-lg bg-gray-50 shadow-sm"
//           >
//             <div className={AD.formGrid2}>
//               <Input
//                 label="Type"
//                 value={t.type}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "type", v)}
//               />
//               <Input
//                 label="Price"
//                 type="number"
//                 value={t.price}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "price", v)}
//               />
//               <Input
//                 label="Currency"
//                 value={t.currency}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "currency", v)}
//               />
//               <Input
//                 label="Total Seats"
//                 type="number"
//                 value={t.totalSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "totalSeats", v)}
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={t.availableSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "availableSeats", v)}
//               />
//             </div>
//             <div className="mt-4">
//               <label className="block font-medium text-gray-700">Perks</label>
//               {t.perks.map((perk, j) => (
//                 <div key={j} className="flex items-center gap-2 mb-2">
//                   <input
//                     className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//                     value={perk}
//                     onChange={(e) => {
//                       const updated = [...t.perks];
//                       updated[j] = e.target.value;
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                     placeholder="Add a perk..."
//                   />
//                   <button
//                     type="button"
//                     className="text-red-500 hover:text-red-700"
//                     onClick={() => {
//                       const updated = t.perks.filter((_, idx) => idx !== j);
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                   >
//                     <FaTrash />
//                   </button>
//                 </div>
//               ))}
//               <button
//                 type="button"
//                 className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//                 onClick={() => onArrayChange("ticketCategories", i, "perks", [...t.perks, ""])}
//               >
//                 <FaPlus /> Add Perk
//               </button>
//             </div>
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700 mt-2 flex items-center gap-1"
//               onClick={() => removeArrayItem("ticketCategories", i)}
//             >
//               <FaTrash /> Remove Ticket
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() =>
//             addArrayItem("ticketCategories", {
//               type: "",
//               price: "",
//               currency: "INR",
//               totalSeats: "",
//               availableSeats: "",
//               perks: [""],
//             })
//           }
//         >
//           <FaPlus /> Add Ticket
//         </button>
//       </Section>

//       {/* Showtimes */}
//       <Section title="Showtimes">
//         {form.showtimes.map((s, i) => (
//           <div
//             key={i}
//             className="border p-4 my-2 rounded-lg bg-gray-50 shadow-sm"
//           >
//             <div className={AD.formGrid2}>
//               <Input
//                 label="Start Time"
//                 type="datetime-local"
//                 value={s.startTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "startTime", v)}
//               />
//               <Input
//                 label="End Time"
//                 type="datetime-local"
//                 value={s.endTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "endTime", v)}
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={s.availableSeats}
//                 onChange={(v) => onArrayChange("showtimes", i, "availableSeats", v)}
//               />
//               <Input
//                 label="Ticket Price"
//                 type="number"
//                 value={s.ticketPrice}
//                 onChange={(v) => onArrayChange("showtimes", i, "ticketPrice", v)}
//               />
//             </div>
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700 mt-2 flex items-center gap-1"
//               onClick={() => removeArrayItem("showtimes", i)}
//             >
//               <FaTrash /> Remove Showtime
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() =>
//             addArrayItem("showtimes", {
//               startTime: "",
//               endTime: "",
//               availableSeats: "",
//               ticketPrice: "",
//             })
//           }
//         >
//           <FaPlus /> Add Showtime
//         </button>
//       </Section>

//       {/* Images */}
//       <Section title="Images">
//         <div>
//           <label className="block font-medium text-gray-700">Poster Image</label>
//           <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
//             <input
//               type="file"
//               accept="image/*"
//               className="hidden"
//               id="poster-upload"
//               onChange={handlePosterFile}
//             />
//             <label
//               htmlFor="poster-upload"
//               className="cursor-pointer text-blue-500 hover:text-blue-700"
//             >
//               {uploadProgress["poster"] ? (
//                 <FaSpinner className="animate-spin inline-block mr-2" />
//               ) : (
//                 "Choose or drag a poster image"
//               )}
//             </label>
//           </div>
//           {form.imageUrl && (
//             <div className="mt-2">
//               <img
//                 src={form.imageUrl}
//                 alt="Poster Preview"
//                 className="h-24 w-24 object-cover rounded"
//               />
//               <p className="text-sm text-gray-600 break-all mt-1">{form.imageUrl}</p>
//             </div>
//           )}
//         </div>

//         <label className="block font-medium text-gray-700 mt-4">Landscape Images</label>
//         {form.landsacpImage.map((img, i) => (
//           <div key={i} className="flex flex-col md:flex-row gap-2 mb-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//               placeholder="Paste image URL (optional)"
//               value={img}
//               onChange={(e) => {
//                 const imgs = [...form.landsacpImage];
//                 imgs[i] = e.target.value;
//                 onChange("landsacpImage", imgs);
//               }}
//             />
//             <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center">
//               <input
//                 type="file"
//                 accept="image/*"
//                 className="hidden"
//                 id={`landscape-upload-${i}`}
//                 onChange={(e) => handleLandscapeFile(e, i)}
//               />
//               <label
//                 htmlFor={`landscape-upload-${i}`}
//                 className="cursor-pointer text-blue-500 hover:text-blue-700"
//               >
//                 {uploadProgress[`landscape-${i}`] ? (
//                   <FaSpinner className="animate-spin inline-block mr-2" />
//                 ) : (
//                   "Choose or drag image"
//                 )}
//               </label>
//             </div>
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700"
//               onClick={() => removeArrayItem("landsacpImage", i)}
//             >
//               <FaTrash />
//             </button>
//             {img && (
//               <img
//                 src={img}
//                 alt={`Landscape ${i + 1}`}
//                 className="h-16 w-16 object-cover rounded mt-2"
//               />
//             )}
//           </div>
//         ))}

//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() => onChange("landsacpImage", [...form.landsacpImage, ""])}
//         >
//           <FaPlus /> Add Landscape Image
//         </button>
//       </Section>

//       {/* Organizer */}
//       <Section title="Organizer">
//         <div className={AD.formGrid2}>
//           {Object.keys(form.organizer)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={k.charAt(0).toUpperCase() + k.slice(1)}
//                 value={form.organizer[k]}
//                 onChange={(v) => onNestedChange("organizer", k, v)}
//                 type={k === "contactEmail" ? "email" : k === "contactPhone" ? "tel" : "text"}
//               />
//             ))}
//         </div>
//         <div className="mt-4">
//           <label className="block font-medium text-gray-700">Organizer Logo</label>
//           <div className="flex flex-col md:flex-row gap-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//               placeholder="Paste logo URL (optional)"
//               value={form.organizer.logoUrl}
//               onChange={(e) => onNestedChange("organizer", "logoUrl", e.target.value)}
//             />
//             <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center">
//               <input
//                 type="file"
//                 accept="image/*"
//                 className="hidden"
//                 id="organizer-logo-upload"
//                 onChange={handleOrganizerLogoFile}
//               />
//               <label
//                 htmlFor="organizer-logo-upload"
//                 className="cursor-pointer text-blue-500 hover:text-blue-700"
//               >
//                 {uploadProgress["organizer"] ? (
//                   <FaSpinner className="animate-spin inline-block mr-2" />
//                 ) : (
//                   "Choose or drag logo"
//                 )}
//               </label>
//             </div>
//           </div>
//           {form.organizer.logoUrl && (
//             <div className="mt-2 flex items-center gap-3">
//               <img
//                 src={form.organizer.logoUrl}
//                 alt="Organizer Logo"
//                 className="h-16 w-16 object-cover rounded"
//               />
//               <p className="text-sm text-gray-600 break-all">{form.organizer.logoUrl}</p>
//             </div>
//           )}
//         </div>
//       </Section>

//       {/* Sponsors */}
//       <Section title="Sponsors">
//         {form.sponsors.map((s, i) => (
//           <div
//             key={i}
//             className="border p-4 my-2 rounded-lg bg-gray-50 shadow-sm"
//           >
//             <div className={AD.formGrid2}>
//               <Input
//                 label="Name"
//                 value={s.name}
//                 onChange={(v) => onArrayChange("sponsors", i, "name", v)}
//               />
//               <Select
//                 label="Type"
//                 value={s.type}
//                 options={["Title Sponsor",
//                   "Presenting Sponsor",
//                   "Powered By Sponsor",
//                   "Associate Sponsor",
//                   "Official Partner",
//                   "Official Beverage Partner",
//                   "Official Food Partner",
//                   "Official Travel Partner",
//                   "Official Airline Partner",
//                   "Official Transport Partner",
//                   "Official Hotel Partner",
//                   "Official Hospitality Partner",
//                   "Official Bank Partner",
//                   "Official Insurance Partner",
//                   "Official Payment Partner",
//                   "Official Apparel Partner",
//                   "Official Footwear Partner",
//                   "Official Merchandise Partner",
//                   "Official Electronics Partner",
//                   "Official Technology Partner",
//                   "Official Streaming Partner",
//                   "Official Ticketing Partner",
//                   "Official Education Partner",
//                   "Official Telecom Partner",
//                   "Venue Partner",
//                   "Logistics Partner",
//                   "Stage & Equipment Partner",
//                   "Printing Partner",
//                   "Security Partner",
//                   "Decoration Partner",
//                   "Photography Partner",
//                   "Medical Partner",
//                   "Gifts Partner",
//                   "Print Media Partner",
//                   "TV Media Partner",
//                   "Radio Partner",
//                   "Digital Media Partner",
//                   "Outdoor Media Partner",
//                   "Social Media Partner",
//                   "Accommodation Partner",
//                   "Catering Partner",
//                   "Food & Beverage Partner",
//                   "Lounge Partner",
//                   "App Partner",
//                   "WiFi Partner",
//                   "Virtual Event Partner",
//                   "AR/VR Partner",
//                   "Gaming Partner",
//                   "NGO Partner",
//                   "Environmental Partner",
//                   "Government Partner",
//                   "Cultural Partner"]}
//                 onChange={(v) => onArrayChange("sponsors", i, "type", v)}
//               />
//             </div>
//             <Textarea
//               label="Description"
//               value={s.description}
//               onChange={(v) => onArrayChange("sponsors", i, "description", v)}
//               rows={3}
//             />
//             <div className="mt-4">
//               <label className="block font-medium text-gray-700">Logo</label>
//               <div className="flex flex-col md:flex-row gap-2">
//                 <input
//                   className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//                   placeholder="Paste logo URL (optional)"
//                   value={s.logo}
//                   onChange={(e) => onArrayChange("sponsors", i, "logo", e.target.value)}
//                 />
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center">
//                   <input
//                     type="file"
//                     accept="image/*"
//                     className="hidden"
//                     id={`sponsor-logo-upload-${i}`}
//                     onChange={(e) => handleSponsorLogoFile(e, i)}
//                   />
//                   <label
//                     htmlFor={`sponsor-logo-upload-${i}`}
//                     className="cursor-pointer text-blue-500 hover:text-blue-700"
//                   >
//                     {uploadProgress[`sponsor-${i}`] ? (
//                       <FaSpinner className="animate-spin inline-block mr-2" />
//                     ) : (
//                       "Choose or drag logo"
//                     )}
//                   </label>
//                 </div>
//               </div>
//               {s.logo && (
//                 <div className="mt-2 flex items-center gap-3">
//                   <img
//                     src={s.logo}
//                     alt={`Sponsor ${i + 1} logo`}
//                     className="h-16 w-16 object-cover rounded"
//                   />
//                   <p className="text-sm text-gray-600 break-all">{s.logo}</p>
//                 </div>
//               )}
//             </div>
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700 mt-2 flex items-center gap-1"
//               onClick={() => removeArrayItem("sponsors", i)}
//             >
//               <FaTrash /> Remove Sponsor
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() =>
//             addArrayItem("sponsors", {
//               name: "",
//               logo: "",
//               description: "",
//               type: "Title Sponsor",
//             })
//           }
//         >
//           <FaPlus /> Add Sponsor
//         </button>
//       </Section>

//       {/* Terms & Conditions */}
//       <Section title="Terms & Conditions">
//         {form.termsAndConditions.map((t, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//               placeholder="Write a point..."
//               value={t.point}
//               onChange={(e) => onArrayChange("termsAndConditions", i, "point", e.target.value)}
//             />
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700"
//               onClick={() => removeArrayItem("termsAndConditions", i)}
//             >
//               <FaTrash />
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() => addArrayItem("termsAndConditions", { point: "" })}
//         >
//           <FaPlus /> Add Point
//         </button>
//       </Section>

//       {/* Tags */}
//       <Section title="Tags">
//         {form.tags.map((tag, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//               placeholder="Add a tag..."
//               value={tag}
//               onChange={(e) => {
//                 const updated = [...form.tags];
//                 updated[i] = e.target.value;
//                 onChange("tags", updated);
//               }}
//             />
//             <button
//               type="button"
//               className="text-red-500 hover:text-red-700"
//               onClick={() => removeArrayItem("tags", i)}
//             >
//               <FaTrash />
//             </button>
//           </div>
//         ))}
//         <button
//           type="button"
//           className="text-blue-500 hover:text-blue-700 flex items-center gap-1"
//           onClick={() => onChange("tags", [...form.tags, ""])}
//         >
//           <FaPlus /> Add Tag
//         </button>
//       </Section>

//       {/* Other Details */}
//       <Section title="Other Details">
//         <div className={AD.formGrid2}>
//           <Select
//             label="Status"
//             value={form.status}
//             options={["Upcoming", "Live"]}
//             onChange={(v) => onChange("status", v)}
//           />
//           <Input
//             label="Remark"
//             value={form.remark}
//             onChange={(v) => onChange("remark", v)}
//           />
//           <Input
//             label="Age Restriction"
//             type="number"
//             value={form.ageRestriction}
//             onChange={(v) => onChange("ageRestriction", v)}
//           />
//           <Input
//             label="Language"
//             value={form.language}
//             onChange={(v) => onChange("language", v)}
//           />
//           <Input
//             label="Duration (minutes)"
//             type="number"
//             value={form.duration}
//             onChange={(v) => onChange("duration", v)}
//           />
//           <Input
//             label="Average Rating"
//             type="number"
//             value={form.ratings.averageRating}
//             onChange={(v) => onNestedChange("ratings", "averageRating", v)}
//             step="0.1"
//             min="0"
//             max="5"
//           />
//           <Input
//             label="Total Reviews"
//             type="number"
//             value={form.ratings.totalReviews}
//             onChange={(v) => onNestedChange("ratings", "totalReviews", v)}
//             min="0"
//           />
//         </div>
//         <div className="flex items-center gap-4 mt-4">
//           <label className="flex items-center gap-2">
//             <input
//               type="checkbox"
//               checked={form.isVerified}
//               onChange={(e) => onChange("isVerified", e.target.checked)}
//               className="h-4 w-4 text-blue-600 focus:ring-blue-500"
//             />
//             Premium
//           </label>
//           <label className="flex items-center gap-2">
//             <input
//               type="checkbox"
//               checked={form.isBookingOpen}
//               onChange={(e) => onChange("isBookingOpen", e.target.checked)}
//               className="h-4 w-4 text-blue-600 focus:ring-blue-500"
//             />
//             Booking Open
//           </label>
//           <label className="flex items-center gap-2">
//             <input
//               type="checkbox"
//               checked={form.isActived}
//               onChange={(e) => onChange("isActived", e.target.checked)}
//               className="h-4 w-4 text-blue-600 focus:ring-blue-500"
//             />
//             Active
//           </label>
//         </div>
//       </Section>

//       {/* Submit Button */}
//       <div className="flex items-center gap-3">
//         <button
//           type="submit"
//           className="bg-amber-400 hover:bg-amber-500 text-white px-6 py-2 rounded-lg flex items-center gap-2 disabled:opacity-50"
//           disabled={loading}
//         >
//           {loading ? (
//             <>
//               <FaSpinner className="animate-spin" /> Updating...
//             </>
//           ) : (
//             "Update Event"
//           )}
//         </button>
//       </div>
//     </form>
//   );
// }

// /* Reusable Components */
// const Section = ({ title, children }) => (
//   <div className="p-6 border rounded-lg bg-white shadow-sm">
//     <h2 className="text-lg font-semibold text-gray-800 mb-4">{title}</h2>
//     <div className="space-y-4">{children}</div>
//   </div>
// );

// const Input = ({ label, value, onChange, type = "text", required = false, placeholder }) => (
//   <div>
//     <label className="block font-medium text-gray-700">{label}</label>
//     <input
//       type={type}
//       className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       required={required}
//       placeholder={placeholder}
//       aria-label={label}
//     />
//   </div>
// );

// const Textarea = ({ label, value, onChange, rows = 4, placeholder }) => (
//   <div>
//     <label className="block font-medium text-gray-700">{label}</label>
//     <textarea
//       className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       rows={rows}
//       placeholder={placeholder}
//       aria-label={label}
//     />
//   </div>
// );

// const Select = ({ label, value, onChange, options }) => (
//   <div>
//     <label className="block font-medium text-gray-700">{label}</label>
//     <select
//       className="border p-2 w-full rounded-md focus:ring-2 focus:ring-blue-500"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       aria-label={label}
//     >
//       {options.map((opt) => (
//         <option key={opt} value={opt}>
//           {opt}
//         </option>
//       ))}
//     </select>
//   </div>
// );

// import React, { useEffect, useState } from "react";
// import { useParams, Link, useNavigate } from "react-router-dom";
// import { get, post, put } from "../../../lib/http";
// import { API } from "../../../config/api";
// import { FaPlus, FaTrash, FaSpinner, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
// import RichText from "./RichText";

// /* ---------- helpers ---------- */

// // Format date for input (YYYY-MM-DDTHH:MM)
// function formatDateTimeForInput(value) {
//   if (!value) return "";
//   const d = value instanceof Date ? value : new Date(value);
//   if (isNaN(d)) return "";
//   return d.toISOString().slice(0, 16);
// }

// const toDTLocal = (d) => {
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
// };

// /* =========================================================
//    MAIN
// ========================================================= */

// export default function AdminEventEdit() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     name: "",
//     category: "Music",
//     description: "",
//     venue: {
//       name: "",
//       address: "",
//       city: "",
//       state: "",
//       country: "",
//       pincode: "",
//       latitude: "",
//       longitude: "",
//       capacity: "",
//       logoUrl: ""
//     },
//     date: "",
//     ticketCategories: [
//       { type: "", price: "", currency: "INR", totalSeats: "", availableSeats: "", perks: [""] },
//     ],
//     showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//     imageUrl: "",
//     landsacpImage: [""],
//     status: "Upcoming",
//     organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
//     termsAndConditions: [{ point: "" }],
//     ratings: { averageRating: 0, totalReviews: 0 },
//     isVerified: false,
//     isBookingOpen: true,
//     isActived: true,
//     remark: "",
//     tags: [""],
//     sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//     ageRestriction: "",
//     language: "",
//     duration: "",
//   });

//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState("");
//   const [uploadProgress, setUploadProgress] = useState({});

//   const now = new Date();
//   const startOfTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
//   const minEventDate = toDTLocal(startOfTomorrow);

//   /* ---------- fetch existing event ---------- */
//   useEffect(() => {
//     let isMounted = true;
//     const fetchEvent = async () => {
//       try {
//         setLoading(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(`${API.events.getSinglEvent}/${id}`, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (isMounted) {
//           setForm({
//             name: res.event.name || "",
//             category: res.event.category || "Music",
//             description: res.event.description || "",
//             venue: {
//               name: res.event.venue?.name || "",
//               address: res.event.venue?.address || "",
//               city: res.event.venue?.city || "",
//               state: res.event.venue?.state || "",
//               country: res.event.venue?.country || "",
//               pincode: res.event.venue?.pincode || "",
//               latitude: res.event.venue?.latitude || "",
//               longitude: res.event.venue?.longitude || "",
//               capacity: res.event.venue?.capacity || "",
//               logoUrl: res.event.venue?.logoUrl || "",
//             },
//             date: formatDateTimeForInput(res.event.date) || "",
//             ticketCategories:
//               res.event.ticketCategories?.length > 0
//                 ? res.event.ticketCategories
//                 : [{ type: "", price: "", currency: "INR", totalSeats: "", availableSeats: "", perks: [""] }],
//             showtimes:
//               res.event.showtimes?.length > 0
//                 ? res.event.showtimes.map((s) => ({
//                   startTime: formatDateTimeForInput(s.startTime),
//                   endTime: formatDateTimeForInput(s.endTime),
//                   availableSeats: s.availableSeats || "",
//                   ticketPrice: s.ticketPrice || "",
//                 }))
//                 : [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//             imageUrl: res.event.imageUrl || "",
//             landsacpImage: res.event.landsacpImage?.length > 0 ? res.event.landsacpImage : [""],
//             status: res.event.status || "Upcoming",
//             organizer: {
//               name: res.event.organizer?.name || "",
//               contactEmail: res.event.organizer?.contactEmail || "",
//               contactPhone: res.event.organizer?.contactPhone || "",
//               website: res.event.organizer?.website || "",
//               logoUrl: res.event.organizer?.logoUrl || "",
//             },
//             termsAndConditions:
//               res.event.termsAndConditions?.length > 0
//                 ? res.event.termsAndConditions
//                 : [{ point: "" }],
//             ratings: {
//               averageRating: res.event.ratings?.averageRating || 0,
//               totalReviews: res.event.ratings?.totalReviews || 0,
//             },
//             isVerified: res.event.isVerified || false,
//             isBookingOpen: res.event.isBookingOpen || false,
//             isActived: res.event.isActived || true,
//             remark: res.event.remark || "",
//             tags: res.event.tags?.length > 0 ? res.event.tags : [""],
//             sponsors:
//               res.event.sponsors?.length > 0
//                 ? res.event.sponsors
//                 : [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//             ageRestriction: res.event.ageRestriction || "",
//             language: res.event.language || "",
//             duration: res.event.duration || "",
//           });
//         }
//       } catch (err) {
//         if (isMounted) setMessage("❌ Failed to load event details.");
//       } finally {
//         if (isMounted) setLoading(false);
//       }
//     };
//     fetchEvent();
//     return () => {
//       isMounted = false;
//     };
//   }, [id]);

//   /* ---------- state helpers ---------- */
//   const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
//   const onNestedChange = (parent, key, value) =>
//     setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));
//   const onArrayChange = (arrKey, index, key, value) => {
//     const updated = [...form[arrKey]];
//     updated[index][key] = value;
//     setForm((f) => ({ ...f, [arrKey]: updated }));
//   };

//   const addArrayItem = (arrKey, newItem) =>
//     setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
//   const removeArrayItem = (arrKey, index) =>
//     setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

//   /* ---------- upload ---------- */
//   const uploadFileAndGetUrl = async (file, key = null) => {
//     if (!file) return "";
//     const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//     const fd = new FormData();
//     fd.append("file", file);
//     setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 0 }));
//     const resp = await post(API.events.fileUploader, fd, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 100 }));

//     if (!resp.success) {
//       throw new Error(resp?.message || "Upload failed");
//     }
//     const url =
//       resp?.url ||
//       resp?.resp?.url ||
//       resp?.fileUrl ||
//       resp?.location ||
//       resp?.path ||
//       resp?.secure_url ||
//       "";
//     if (!url) throw new Error("Upload success but no URL found in response.");
//     return url;
//   };

//   const handlePosterFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading poster...");
//       const url = await uploadFileAndGetUrl(file, "poster");
//       onChange("imageUrl", url);
//       setMessage("✅ Poster uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Poster upload failed.");
//     }
//   };

//   const handleLandscapeFile = async (e, index) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage(`Uploading landscape image ${index + 1}...`);
//       const url = await uploadFileAndGetUrl(file, `landscape-${index}`);
//       const imgs = [...form.landsacpImage];
//       imgs[index] = url;
//       onChange("landsacpImage", imgs);
//       setMessage("✅ Landscape image uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Landscape upload failed.");
//     }
//   };

//   const handleSponsorLogoFile = async (e, index) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage(`Uploading sponsor ${index + 1} logo...`);
//       const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
//       onArrayChange("sponsors", index, "logo", url);
//       setMessage("✅ Sponsor logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Sponsor logo upload failed.");
//     }
//   };

//   const handleOrganizerLogoFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading organizer logo...");
//       const url = await uploadFileAndGetUrl(file, "organizer");
//       onNestedChange("organizer", "logoUrl", url);
//       setMessage("✅ Organizer logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Organizer logo upload failed.");
//     }
//   };

//   const handleVenueLogoFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading venue logo...");
//       const url = await uploadFileAndGetUrl(file, "venue");
//       onNestedChange("venue", "logoUrl", url);
//       setMessage("✅ Venue logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Venue logo upload failed.");
//     }
//   };

//   /* ---------- submit ---------- */
//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage("");
//     try {
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       await put(`${API.events.editEvent}/${id}`, form, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "application/json",
//         },
//       });
//       setMessage("✅ Event updated successfully!");
//       setTimeout(() => navigate("/admin/events"), 1200);
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Failed to update event.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ---------- loading skeleton ---------- */
//   if (loading) {
//     return (
//       <div className="max-w-6xl mx-auto p-6">
//         <div className="bg-white shadow-lg rounded-2xl p-6 animate-pulse">
//           <div className="h-8 w-1/3 bg-gray-200 rounded-lg mb-6" />
//           <div className="space-y-4">
//             <div className="h-6 w-1/2 bg-gray-200 rounded-lg" />
//             <div className="h-6 w-3/4 bg-gray-200 rounded-lg" />
//             <div className="h-6 w-1/4 bg-gray-200 rounded-lg" />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   /* ---------- UI ---------- */
//   return (
//     <form
//       onSubmit={onSubmit}
//       className="max-w-6xl mx-auto p-6 bg-gradient-to-b from-slate-50 to-white space-y-6"
//     >
//       {/* header */}
//       <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
//         <div>
//           <h1 className="text-2xl font-bold text-slate-900">Edit Event</h1>
//           <p className="text-sm text-slate-500">Update details and save changes</p>
//         </div>
//         <div className="flex items-center gap-2">
//           <Link
//             to={`/admin/events/view/${id}`}
//             className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-slate-700 hover:bg-slate-50"
//           >
//             <FaPlus className="opacity-70" />
//             Back to View
//           </Link>
//           <PrimaryButton type="submit" disabled={loading}>
//             {loading ? <><FaSpinner className="animate-spin" /> Updating…</> : "Update Event"}
//           </PrimaryButton>
//         </div>
//       </div>

//       {message && (
//         <div className={`flex items-center gap-2 text-sm ${message.includes("✅") ? "text-emerald-700" : "text-red-600"}`}>
//           {message.includes("✅") ? <FaCheckCircle /> : <FaTimesCircle />}
//           {message}
//         </div>
//       )}

//       {/* BASIC INFO */}
//       <Section
//         title="Basic Info"
//         subtitle="Core information visible to customers"
//       >
//         <div className={AD.formGrid2}>
//           <Input label="Event Name" value={form.name} onChange={(v) => onChange("name", v)} required />
//           <Select
//             label="Category"
//             value={form.category}
//             onChange={(v) => onChange("category", v)}
//             options={[
//               "Music",
//               "Theatre",
//               "Comedy",
//               "Dance",
//               "Sports",
//               "Exhibition",
//               "Festival",
//               "Conference",
//               "Workshop",
//               "Other",
//             ]}
//           />
//           <Input
//             label="Event Date"
//             type="datetime-local"
//             value={form.date}
//             onChange={(v) => {
//               const picked = new Date(v);
//               if (picked < startOfTomorrow) {
//                 setMessage("❌ Event Date must be after today.");
//                 return;
//               }
//               onChange("date", v);
//             }}
//             required
//             min={minEventDate}
//             hint="Must be in the future"
//           />
//           <Input label="Language" value={form.language} onChange={(v) => onChange("language", v)} />
//         </div>
//         {/* <Textarea label="Description" value={form.description} onChange={(v) => onChange("description", v)} /> */}
//         <RichText
//           label="Description"
//           value={form.description}                 // HTML aa/jaa sakta hai
//           onChange={(html) => onChange("description", html)}
//           placeholder="Write details about this event…"
//           minHeight={260}
//         />

//       </Section>

//       {/* VENUE */}
//       <Section
//         title="Venue"
//         subtitle="Where the event is hosted"
//       >
//         <div className={AD.formGrid2}>
//           {Object.keys(form.venue)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={k.charAt(0).toUpperCase() + k.slice(1)}
//                 value={form.venue[k]}
//                 onChange={(v) => onNestedChange("venue", k, v)}
//                 type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
//               />
//             ))}
//         </div>

//         {/* logo upload */}
//         <div className="mt-2">
//           <Label>Venue Logo</Label>
//           <UploadRow
//             inputId="venue-logo-upload"
//             onFile={handleVenueLogoFile}
//             progress={uploadProgress["venue"]}
//             value={form.venue.logoUrl}
//             onChange={(v) => onNestedChange("venue", "logoUrl", v)}
//           />
//           {form.venue.logoUrl && <Thumb src={form.venue.logoUrl} alt="Venue Logo" />}
//         </div>
//       </Section>

//       {/* TICKET CATEGORIES */}
//       <Section
//         title="Ticket Categories"
//         subtitle="Configure pricing, inventory and perks"
//       >
//         {form.ticketCategories.map((t, i) => (
//           <div key={i} className="border p-4 my-2 rounded-2xl bg-white shadow-sm hover:shadow-md transition">
//             <div className={AD.formGrid2}>
//               <Input label="Type" value={t.type} onChange={(v) => onArrayChange("ticketCategories", i, "type", v)} />
//               <Input label="Price" type="number" value={t.price} onChange={(v) => onArrayChange("ticketCategories", i, "price", v)} />
//               <Input label="Currency" value={t.currency} onChange={(v) => onArrayChange("ticketCategories", i, "currency", v)} />
//               <Input label="Total Seats" type="number" value={t.totalSeats} onChange={(v) => onArrayChange("ticketCategories", i, "totalSeats", v)} />
//               <Input label="Available Seats" type="number" value={t.availableSeats} onChange={(v) => onArrayChange("ticketCategories", i, "availableSeats", v)} />
//             </div>

//             <div className="mt-4">
//               <Label>Perks</Label>
//               {t.perks.map((perk, j) => (
//                 <div key={j} className="flex items-center gap-2 mb-2">
//                   <input
//                     className={baseInput}
//                     value={perk}
//                     onChange={(e) => {
//                       const updated = [...t.perks];
//                       updated[j] = e.target.value;
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                     placeholder="Add a perk…"
//                   />
//                   <IconButton aria="Remove perk" onClick={() => {
//                     const updated = t.perks.filter((_, idx) => idx !== j);
//                     onArrayChange("ticketCategories", i, "perks", updated);
//                   }}>
//                     <FaTrash />
//                   </IconButton>
//                 </div>
//               ))}
//               <GhostButton onClick={() => onArrayChange("ticketCategories", i, "perks", [...t.perks, ""])}>
//                 <FaPlus /> Add Perk
//               </GhostButton>
//             </div>

//             <div className="mt-3">
//               <DangerLink onClick={() => removeArrayItem("ticketCategories", i)}>
//                 <FaTrash /> Remove Ticket
//               </DangerLink>
//             </div>
//           </div>
//         ))}

//         <PrimaryButton
//           type="button"
//           className="mt-2"
//           onClick={() =>
//             addArrayItem("ticketCategories", {
//               type: "",
//               price: "",
//               currency: "INR",
//               totalSeats: "",
//               availableSeats: "",
//               perks: [""],
//             })
//           }
//         >
//           <FaPlus /> Add Ticket
//         </PrimaryButton>
//       </Section>

//       {/* SHOWTIMES */}
//       <Section
//         title="Showtimes"
//         subtitle="Add one or more schedules with pricing"
//       >
//         {form.showtimes.map((s, i) => (
//           <div key={i} className="border p-4 my-2 rounded-2xl bg-white shadow-sm hover:shadow-md transition">
//             <div className={AD.formGrid2}>
//               <Input label="Start Time" type="datetime-local" value={s.startTime} onChange={(v) => onArrayChange("showtimes", i, "startTime", v)} />
//               <Input label="End Time" type="datetime-local" value={s.endTime} onChange={(v) => onArrayChange("showtimes", i, "endTime", v)} />
//               <Input label="Available Seats" type="number" value={s.availableSeats} onChange={(v) => onArrayChange("showtimes", i, "availableSeats", v)} />
//               <Input label="Ticket Price" type="number" value={s.ticketPrice} onChange={(v) => onArrayChange("showtimes", i, "ticketPrice", v)} />
//             </div>
//             <div className="mt-3">
//               <DangerLink onClick={() => removeArrayItem("showtimes", i)}>
//                 <FaTrash /> Remove Showtime
//               </DangerLink>
//             </div>
//           </div>
//         ))}

//         <PrimaryButton
//           type="button"
//           onClick={() =>
//             addArrayItem("showtimes", {
//               startTime: "",
//               endTime: "",
//               availableSeats: "",
//               ticketPrice: "",
//             })
//           }
//         >
//           <FaPlus /> Add Showtime
//         </PrimaryButton>
//       </Section>

//       {/* IMAGES */}
//       <Section
//         title="Images"
//         subtitle="Poster and landscape gallery"
//       >
//         {/* Poster */}
//         <div>
//           <Label>Poster Image</Label>
//           <div className="border-2 border-dashed rounded-2xl p-4 text-center bg-white">
//             <input type="file" accept="image/*" className="hidden" id="poster-upload" onChange={handlePosterFile} />
//             <label htmlFor="poster-upload" className="cursor-pointer text-amber-700 hover:underline">
//               {uploadProgress["poster"] ? <span className="inline-flex items-center gap-2"><FaSpinner className="animate-spin" /> Uploading…</span> : "Choose or drag a poster image"}
//             </label>
//             {uploadProgress["poster"] ? (
//               <div className="mt-3 h-1.5 rounded bg-slate-100">
//                 <div className="h-1.5 rounded bg-amber-400" style={{ width: `${uploadProgress["poster"]}%` }} />
//               </div>
//             ) : null}
//           </div>
//           {form.imageUrl && <Thumb src={form.imageUrl} alt="Poster Preview" large />}
//         </div>

//         {/* Landscape */}
//         <div className="mt-4">
//           <Label>Landscape Images</Label>
//           {form.landsacpImage.map((img, i) => (
//             <div key={i} className="mb-3">
//               <UploadRow
//                 inputId={`landscape-upload-${i}`}
//                 onFile={(e) => handleLandscapeFile(e, i)}
//                 progress={uploadProgress[`landscape-${i}`]}
//                 value={img}
//                 onChange={(v) => {
//                   const imgs = [...form.landsacpImage];
//                   imgs[i] = v;
//                   onChange("landsacpImage", imgs);
//                 }}
//               />
//               <div className="mt-2 flex items-center gap-2">
//                 <IconButton aria="Remove image" onClick={() => removeArrayItem("landsacpImage", i)}>
//                   <FaTrash />
//                 </IconButton>
//                 {img && <Thumb src={img} alt={`Landscape ${i + 1}`} />}
//               </div>
//             </div>
//           ))}
//           <GhostButton onClick={() => onChange("landsacpImage", [...form.landsacpImage, ""])}>
//             <FaPlus /> Add Landscape Image
//           </GhostButton>
//         </div>
//       </Section>

//       {/* ORGANIZER */}
//       <Section
//         title="Organizer"
//         subtitle="Public information for event host"
//       >
//         <div className={AD.formGrid2}>
//           {Object.keys(form.organizer)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={k.charAt(0).toUpperCase() + k.slice(1)}
//                 value={form.organizer[k]}
//                 onChange={(v) => onNestedChange("organizer", k, v)}
//                 type={k === "contactEmail" ? "email" : k === "contactPhone" ? "tel" : "text"}
//               />
//             ))}
//         </div>

//         <div className="mt-2">
//           <Label>Organizer Logo</Label>
//           <UploadRow
//             inputId="organizer-logo-upload"
//             onFile={handleOrganizerLogoFile}
//             progress={uploadProgress["organizer"]}
//             value={form.organizer.logoUrl}
//             onChange={(v) => onNestedChange("organizer", "logoUrl", v)}
//           />
//           {form.organizer.logoUrl && <Thumb src={form.organizer.logoUrl} alt="Organizer Logo" />}
//         </div>
//       </Section>

//       {/* SPONSORS */}
//       <Section
//         title="Sponsors"
//         subtitle="Show appreciation and manage branding"
//       >
//         {form.sponsors.map((s, i) => (
//           <div key={i} className="border p-4 my-2 rounded-2xl bg-white shadow-sm hover:shadow-md transition">
//             <div className={AD.formGrid2}>
//               <Input label="Name" value={s.name} onChange={(v) => onArrayChange("sponsors", i, "name", v)} />
//               <Select
//                 label="Type"
//                 value={s.type}
//                 options={[
//                   "Title Sponsor", "Presenting Sponsor", "Powered By Sponsor", "Associate Sponsor", "Official Partner",
//                   "Official Beverage Partner", "Official Food Partner", "Official Travel Partner", "Official Airline Partner",
//                   "Official Transport Partner", "Official Hotel Partner", "Official Hospitality Partner", "Official Bank Partner",
//                   "Official Insurance Partner", "Official Payment Partner", "Official Apparel Partner", "Official Footwear Partner",
//                   "Official Merchandise Partner", "Official Electronics Partner", "Official Technology Partner", "Official Streaming Partner",
//                   "Official Ticketing Partner", "Official Education Partner", "Official Telecom Partner", "Venue Partner", "Logistics Partner",
//                   "Stage & Equipment Partner", "Printing Partner", "Security Partner", "Decoration Partner", "Photography Partner",
//                   "Medical Partner", "Gifts Partner", "Print Media Partner", "TV Media Partner", "Radio Partner", "Digital Media Partner",
//                   "Outdoor Media Partner", "Social Media Partner", "Accommodation Partner", "Catering Partner", "Food & Beverage Partner",
//                   "Lounge Partner", "App Partner", "WiFi Partner", "Virtual Event Partner", "AR/VR Partner", "Gaming Partner",
//                   "NGO Partner", "Environmental Partner", "Government Partner", "Cultural Partner"
//                 ]}
//                 onChange={(v) => onArrayChange("sponsors", i, "type", v)}
//               />
//             </div>

//             <Textarea label="Description" value={s.description} onChange={(v) => onArrayChange("sponsors", i, "description", v)} />

//             <div className="mt-2">
//               <Label>Logo</Label>
//               <UploadRow
//                 inputId={`sponsor-logo-upload-${i}`}
//                 onFile={(e) => handleSponsorLogoFile(e, i)}
//                 progress={uploadProgress[`sponsor-${i}`]}
//                 value={s.logo}
//                 onChange={(v) => onArrayChange("sponsors", i, "logo", v)}
//               />
//               {s.logo && <Thumb src={s.logo} alt={`Sponsor ${i + 1} logo`} />}
//             </div>

//             <div className="mt-3">
//               <DangerLink onClick={() => removeArrayItem("sponsors", i)}>
//                 <FaTrash /> Remove Sponsor
//               </DangerLink>
//             </div>
//           </div>
//         ))}

//         <PrimaryButton
//           type="button"
//           onClick={() =>
//             addArrayItem("sponsors", {
//               name: "",
//               logo: "",
//               description: "",
//               type: "Title Sponsor",
//             })
//           }
//         >
//           <FaPlus /> Add Sponsor
//         </PrimaryButton>
//       </Section>

//       {/* TERMS */}
//       <Section title="Terms & Conditions" subtitle="Add points visible on the event page">
//         {form.termsAndConditions.map((t, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className={baseInput}
//               placeholder="Write a point…"
//               value={t.point}
//               onChange={(e) => onArrayChange("termsAndConditions", i, "point", e.target.value)}
//             />
//             <IconButton aria="Remove term" onClick={() => removeArrayItem("termsAndConditions", i)}>
//               <FaTrash />
//             </IconButton>
//           </div>
//         ))}
//         <GhostButton onClick={() => addArrayItem("termsAndConditions", { point: "" })}>
//           <FaPlus /> Add Point
//         </GhostButton>
//       </Section>

//       {/* TAGS */}
//       <Section title="Tags" subtitle="Improve discoverability with keywords">
//         {form.tags.map((tag, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className={baseInput}
//               placeholder="Add a tag…"
//               value={tag}
//               onChange={(e) => {
//                 const updated = [...form.tags];
//                 updated[i] = e.target.value;
//                 onChange("tags", updated);
//               }}
//             />
//             <IconButton aria="Remove tag" onClick={() => removeArrayItem("tags", i)}>
//               <FaTrash />
//             </IconButton>
//           </div>
//         ))}
//         <GhostButton onClick={() => onChange("tags", [...form.tags, ""])}>
//           <FaPlus /> Add Tag
//         </GhostButton>
//       </Section>

//       {/* OTHER */}
//       <Section title="Other Details" subtitle="Operational details and flags">
//         <div className={AD.formGrid2}>
//           <Select label="Status" value={form.status} onChange={(v) => onChange("status", v)} options={["Upcoming", "Live"]} />
//           <Input label="Remark" value={form.remark} onChange={(v) => onChange("remark", v)} />
//           <Input label="Age Restriction" type="number" value={form.ageRestriction} onChange={(v) => onChange("ageRestriction", v)} />
//           <Input label="Duration (minutes)" type="number" value={form.duration} onChange={(v) => onChange("duration", v)} />
//           <Input label="Average Rating" type="number" step="0.1" min="0" max="5" value={form.ratings.averageRating} onChange={(v) => onNestedChange("ratings", "averageRating", v)} />
//           <Input label="Total Reviews" type="number" min="0" value={form.ratings.totalReviews} onChange={(v) => onNestedChange("ratings", "totalReviews", v)} />
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4">
//           <Toggle label="Premium" checked={form.isVerified} onChange={(v) => onChange("isVerified", v)} />
//           <Toggle label="Booking Open" checked={form.isBookingOpen} onChange={(v) => onChange("isBookingOpen", v)} />
//           <Toggle label="Active" checked={form.isActived} onChange={(v) => onChange("isActived", v)} />
//         </div>
//       </Section>

//       {/* footer actions (sticky on mobile feel) */}
//       <div className="flex items-center justify-end gap-2 pt-2">
//         <Link
//           to={`/admin/events/view/${id}`}
//           className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-slate-700 hover:bg-slate-50"
//         >
//           <FaPlus className="opacity-70" />
//           Back to View
//         </Link>
//         <PrimaryButton type="submit" disabled={loading}>
//           {loading ? <><FaSpinner className="animate-spin" /> Updating…</> : "Update Event"}
//         </PrimaryButton>
//       </div>
//     </form>
//   );
// }

// /* =========================================================
//    Reusable UI — polished components
// ========================================================= */

// const Section = ({ title, children, subtitle, icon }) => (
//   <div className="p-6 border rounded-2xl bg-white shadow-sm hover:shadow-md transition-shadow">
//     <div className="flex items-start gap-3 mb-4">
//       {icon ? <div className="text-amber-500 mt-0.5">{icon}</div> : null}
//       <div>
//         <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
//         {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
//       </div>
//     </div>
//     <div className="space-y-4">{children}</div>
//   </div>
// );

// const Label = ({ children }) => (
//   <label className="block text-sm font-medium text-slate-700">{children}</label>
// );

// const baseInput =
//   "mt-1 w-full rounded-xl border bg-white/90 px-3 py-2.5 outline-none " +
//   "focus:ring-2 focus:ring-amber-300 focus:border-amber-300 " +
//   "placeholder:text-slate-400 transition";

// const Input = ({ label, value, onChange, type = "text", required = false, placeholder, hint, step, min, max }) => (
//   <div>
//     {label && <Label>{label}</Label>}
//     <input
//       type={type}
//       className={baseInput}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       required={required}
//       placeholder={placeholder}
//       step={step}
//       min={min}
//       max={max}
//       aria-label={label}
//     />
//     {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
//   </div>
// );

// const Textarea = ({ label, value, onChange, rows = 4, placeholder }) => (
//   <div>
//     {label && <Label>{label}</Label>}
//     <textarea
//       className={`${baseInput} min-h-[120px]`}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       rows={rows}
//       placeholder={placeholder}
//       aria-label={label}
//     />
//   </div>
// );

// const Select = ({ label, value, onChange, options }) => (
//   <div>
//     {label && <Label>{label}</Label>}
//     <select
//       className={`${baseInput} pr-9`}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       aria-label={label}
//     >
//       {options.map((opt) => (
//         <option key={opt} value={opt}>
//           {opt}
//         </option>
//       ))}
//     </select>
//   </div>
// );

// /* Buttons */

// const PrimaryButton = ({ children, className = "", ...props }) => (
//   <button
//     className={`inline-flex items-center gap-2 rounded-full bg-amber-400 px-5 py-2 font-semibold text-slate-900 shadow-sm hover:bg-amber-300 disabled:opacity-60 ${className}`}
//     {...props}
//   >
//     {children}
//   </button>
// );

// const GhostButton = ({ children, className = "", ...props }) => (
//   <button
//     type="button"
//     className={`inline-flex items-center gap-2 text-amber-700 hover:underline text-sm ${className}`}
//     {...props}
//   >
//     {children}
//   </button>
// );

// const DangerLink = ({ children, className = "", ...props }) => (
//   <button
//     type="button"
//     className={`inline-flex items-center gap-2 text-red-600 hover:underline text-sm ${className}`}
//     {...props}
//   >
//     {children}
//   </button>
// );

// const IconButton = ({ children, aria, className = "", ...props }) => (
//   <button
//     type="button"
//     aria-label={aria}
//     className={`inline-flex h-10 w-10 items-center justify-center rounded-lg border bg-white text-slate-600 hover:bg-slate-50 ${className}`}
//     {...props}
//   >
//     {children}
//   </button>
// );

// /* Toggle */

// const Toggle = ({ checked, onChange, label }) => (
//   <label className="flex items-center justify-between gap-3 rounded-xl border px-3 py-2 bg-white">
//     <span className="text-sm font-medium text-slate-800">{label}</span>
//     <button
//       type="button"
//       onClick={() => onChange(!checked)}
//       className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${checked ? "bg-emerald-500" : "bg-slate-300"}`}
//       aria-pressed={checked}
//     >
//       <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${checked ? "translate-x-5" : "translate-x-1"}`} />
//     </button>
//   </label>
// );

// /* Upload */

// const UploadRow = ({ inputId, onFile, progress, value, onChange, placeholder = "Paste image URL (optional)" }) => (
//   <div className="flex flex-col md:flex-row gap-2">
//     <input
//       className={baseInput}
//       placeholder={placeholder}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//     />
//     <div className="border-2 border-dashed rounded-xl p-2 text-center">
//       <input type="file" accept="image/*" className="hidden" id={inputId} onChange={onFile} />
//       <label htmlFor={inputId} className="cursor-pointer text-amber-700 hover:underline">
//         Choose or drag file
//       </label>
//     </div>
//     {typeof progress === "number" ? (
//       <div className="min-w-[140px] self-center text-xs text-slate-500">
//         {progress < 100 ? "Uploading…" : "Done"}
//         <div className="mt-1 h-1.5 rounded bg-slate-100">
//           <div className="h-1.5 rounded bg-amber-400" style={{ width: `${progress}%` }} />
//         </div>
//       </div>
//     ) : null}
//   </div>
// );

// const Thumb = ({ src, alt = "Preview", large = false }) => (
//   <div className="mt-3 flex items-center gap-3">
//     <img
//       src={src}
//       alt={alt}
//       className={`${large ? "h-40 w-40" : "h-16 w-16"} rounded-xl border object-cover`}
//       onError={(e) => (e.currentTarget.src = "https://via.placeholder.com/150?text=Image")}
//     />
//     <p className="break-all text-xs text-slate-500">{src}</p>
//   </div>
// );


// src/pages/admin/events/AdminEventEdit.jsx
// import React, { useEffect, useState } from "react";
// import { useParams, Link, useNavigate } from "react-router-dom";
// import { get, post, put } from "../../../lib/http";
// import { API } from "../../../config/api";
// import { FaPlus, FaTrash, FaSpinner, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
// import RichText from "./RichText";

// /* ---------- helpers ---------- */

// // Format date for input (YYYY-MM-DDTHH:MM)
// function formatDateTimeForInput(value) {
//   if (!value) return "";
//   const d = value instanceof Date ? value : new Date(value);
//   if (isNaN(d)) return "";
//   return d.toISOString().slice(0, 16);
// }

// const toDTLocal = (d) => {
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
// };

// /* =========================================================
//    MAIN
// ========================================================= */

// export default function AdminEventEdit() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     name: "",
//     category: "Music",
//     description: "",
//     venue: {
//       name: "",
//       address: "",
//       city: "",
//       state: "",
//       country: "",
//       pincode: "",
//       latitude: "",
//       longitude: "",
//       capacity: "",
//       logoUrl: ""
//     },
//     date: "",
//     ticketCategories: [
//       {
//         type: "",
//         price: "",
//         currency: "INR",
//         totalSeats: "",
//         availableSeats: "",
//         perks: [""],
//         isTicketAvailable: true, // NEW
//       },
//     ],
//     showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//     imageUrl: "",
//     landsacpImage: [""],
//     status: "Upcoming",
//     organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
//     termsAndConditions: [{ point: "" }],
//     ratings: { averageRating: 0, totalReviews: 0 },
//     isVerified: false,
//     isBookingOpen: true,
//     isActived: true,
//     remark: "",
//     tags: [""],
//     sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//     ageRestriction: "",
//     language: "",
//     duration: "",
//   });

//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState("");
//   const [uploadProgress, setUploadProgress] = useState({});

//   const now = new Date();
//   const startOfTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
//   const minEventDate = toDTLocal(startOfTomorrow);

//   /* ---------- fetch existing event ---------- */
//   useEffect(() => {
//     let isMounted = true;
//     const fetchEvent = async () => {
//       try {
//         setLoading(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(`${API.events.getSinglEvent}/${id}`, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (isMounted) {
//           setForm({
//             name: res.event.name || "",
//             category: res.event.category || "Music",
//             description: res.event.description || "",
//             venue: {
//               name: res.event.venue?.name || "",
//               address: res.event.venue?.address || "",
//               city: res.event.venue?.city || "",
//               state: res.event.venue?.state || "",
//               country: res.event.venue?.country || "",
//               pincode: res.event.venue?.pincode || "",
//               latitude: res.event.venue?.latitude || "",
//               longitude: res.event.venue?.longitude || "",
//               capacity: res.event.venue?.capacity || "",
//               logoUrl: res.event.venue?.logoUrl || "",
//             },
//             date: formatDateTimeForInput(res.event.date) || "",
//             ticketCategories:
//               res.event.ticketCategories?.length > 0
//                 ? res.event.ticketCategories.map((t) => ({
//                   ...t,
//                   // default to true if missing in older records
//                   isTicketAvailable: t?.isTicketAvailable ?? true,
//                   perks: Array.isArray(t?.perks) ? t.perks : [""],
//                 }))
//                 : [{
//                   type: "",
//                   price: "",
//                   currency: "INR",
//                   totalSeats: "",
//                   availableSeats: "",
//                   perks: [""],
//                   isTicketAvailable: true,
//                 }],
//             showtimes:
//               res.event.showtimes?.length > 0
//                 ? res.event.showtimes.map((s) => ({
//                   startTime: formatDateTimeForInput(s.startTime),
//                   endTime: formatDateTimeForInput(s.endTime),
//                   availableSeats: s.availableSeats || "",
//                   ticketPrice: s.ticketPrice || "",
//                 }))
//                 : [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//             imageUrl: res.event.imageUrl || "",
//             landsacpImage: res.event.landsacpImage?.length > 0 ? res.event.landsacpImage : [""],
//             status: res.event.status || "Upcoming",
//             organizer: {
//               name: res.event.organizer?.name || "",
//               contactEmail: res.event.organizer?.contactEmail || "",
//               contactPhone: res.event.organizer?.contactPhone || "",
//               website: res.event.organizer?.website || "",
//               logoUrl: res.event.organizer?.logoUrl || "",
//             },
//             termsAndConditions:
//               res.event.termsAndConditions?.length > 0
//                 ? res.event.termsAndConditions
//                 : [{ point: "" }],
//             ratings: {
//               averageRating: res.event.ratings?.averageRating || 0,
//               totalReviews: res.event.ratings?.totalReviews || 0,
//             },
//             isVerified: res.event.isVerified || false,
//             isBookingOpen: res.event.isBookingOpen || false,
//             isActived: res.event.isActived ?? true,
//             remark: res.event.remark || "",
//             tags: res.event.tags?.length > 0 ? res.event.tags : [""],
//             sponsors:
//               res.event.sponsors?.length > 0
//                 ? res.event.sponsors
//                 : [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//             ageRestriction: res.event.ageRestriction || "",
//             language: res.event.language || "",
//             duration: res.event.duration || "",
//           });
//         }
//       } catch (err) {
//         if (isMounted) setMessage("❌ Failed to load event details.");
//       } finally {
//         if (isMounted) setLoading(false);
//       }
//     };
//     fetchEvent();
//     return () => {
//       isMounted = false;
//     };
//   }, [id]);

//   /* ---------- state helpers ---------- */
//   const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
//   const onNestedChange = (parent, key, value) =>
//     setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));
//   const onArrayChange = (arrKey, index, key, value) => {
//     const updated = [...form[arrKey]];
//     updated[index][key] = value;
//     setForm((f) => ({ ...f, [arrKey]: updated }));
//   };

//   const addArrayItem = (arrKey, newItem) =>
//     setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
//   const removeArrayItem = (arrKey, index) =>
//     setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

//   /* ---------- upload ---------- */
//   const uploadFileAndGetUrl = async (file, key = null) => {
//     if (!file) return "";
//     const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//     const fd = new FormData();
//     fd.append("file", file);
//     setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 0 }));
//     const resp = await post(API.events.fileUploader, fd, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 100 }));

//     if (!resp.success) {
//       throw new Error(resp?.message || "Upload failed");
//     }
//     const url =
//       resp?.url ||
//       resp?.resp?.url ||
//       resp?.fileUrl ||
//       resp?.location ||
//       resp?.path ||
//       resp?.secure_url ||
//       "";
//     if (!url) throw new Error("Upload success but no URL found in response.");
//     return url;
//   };

//   const handlePosterFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading poster...");
//       const url = await uploadFileAndGetUrl(file, "poster");
//       onChange("imageUrl", url);
//       setMessage("✅ Poster uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Poster upload failed.");
//     }
//   };

//   const handleLandscapeFile = async (e, index) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage(`Uploading landscape image ${index + 1}...`);
//       const url = await uploadFileAndGetUrl(file, `landscape-${index}`);
//       const imgs = [...form.landsacpImage];
//       imgs[index] = url;
//       onChange("landsacpImage", imgs);
//       setMessage("✅ Landscape image uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Landscape upload failed.");
//     }
//   };

//   const handleSponsorLogoFile = async (e, index) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage(`Uploading sponsor ${index + 1} logo...`);
//       const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
//       onArrayChange("sponsors", index, "logo", url);
//       setMessage("✅ Sponsor logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Sponsor logo upload failed.");
//     }
//   };

//   const handleOrganizerLogoFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading organizer logo...");
//       const url = await uploadFileAndGetUrl(file, "organizer");
//       onNestedChange("organizer", "logoUrl", url);
//       setMessage("✅ Organizer logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Organizer logo upload failed.");
//     }
//   };

//   const handleVenueLogoFile = async (e) => {
//     try {
//       const file = e.target.files?.[0];
//       if (!file) return;
//       setMessage("Uploading venue logo...");
//       const url = await uploadFileAndGetUrl(file, "venue");
//       onNestedChange("venue", "logoUrl", url);
//       setMessage("✅ Venue logo uploaded.");
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Venue logo upload failed.");
//     }
//   };

//   /* ---------- submit ---------- */
//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage("");
//     try {
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       await put(`${API.events.editEvent}/${id}`, form, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "application/json",
//         },
//       });
//       setMessage("✅ Event updated successfully!");
//       setTimeout(() => navigate("/admin/events"), 1200);
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Failed to update event.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ---------- loading skeleton ---------- */
//   if (loading) {
//     return (
//       <div className="max-w-6xl mx-auto p-6">
//         <div className="bg-white shadow-lg rounded-2xl p-6 animate-pulse">
//           <div className="h-8 w-1/3 bg-gray-200 rounded-lg mb-6" />
//           <div className="space-y-4">
//             <div className="h-6 w-1/2 bg-gray-200 rounded-lg" />
//             <div className="h-6 w-3/4 bg-gray-200 rounded-lg" />
//             <div className="h-6 w-1/4 bg-gray-200 rounded-lg" />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   /* ---------- UI ---------- */
//   return (
//     <form
//       onSubmit={onSubmit}
//       className="max-w-6xl mx-auto p-6 bg-gradient-to-b from-slate-50 to-white space-y-6"
//     >
//       {/* header */}
//       <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
//         <div>
//           <h1 className="text-2xl font-bold text-slate-900">Edit Event</h1>
//           <p className="text-sm text-slate-500">Update details and save changes</p>
//         </div>
//         <div className="flex items-center gap-2">
//           <Link
//             to={`/admin/events/view/${id}`}
//             className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-slate-700 hover:bg-slate-50"
//           >
//             <FaPlus className="opacity-70" />
//             Back to View
//           </Link>
//           <PrimaryButton type="submit" disabled={loading}>
//             {loading ? <><FaSpinner className="animate-spin" /> Updating…</> : "Update Event"}
//           </PrimaryButton>
//         </div>
//       </div>

//       {message && (
//         <div className={`flex items-center gap-2 text-sm ${message.includes("✅") ? "text-emerald-700" : "text-red-600"}`}>
//           {message.includes("✅") ? <FaCheckCircle /> : <FaTimesCircle />}
//           {message}
//         </div>
//       )}

//       {/* BASIC INFO */}
//       <Section
//         title="Basic Info"
//         subtitle="Core information visible to customers"
//       >
//         <div className={AD.formGrid2}>
//           <Input label="Event Name" value={form.name} onChange={(v) => onChange("name", v)} required />
//           <Select
//             label="Category"
//             value={form.category}
//             onChange={(v) => onChange("category", v)}
//             options={[
//               "Music",
//               "Theatre",
//               "Comedy",
//               "Dance",
//               "Sports",
//               "Exhibition",
//               "Festival",
//               "Conference",
//               "Workshop",
//               "Other",
//             ]}
//           />
//           <Input
//             label="Event Date"
//             type="datetime-local"
//             value={form.date}
//             onChange={(v) => {
//               const picked = new Date(v);
//               if (picked < startOfTomorrow) {
//                 setMessage("❌ Event Date must be after today.");
//                 return;
//               }
//               onChange("date", v);
//             }}
//             required
//             min={minEventDate}
//             hint="Must be in the future"
//           />
//           <Input label="Language" value={form.language} onChange={(v) => onChange("language", v)} />
//         </div>

//         <RichText
//           label="Description"
//           value={form.description}
//           onChange={(html) => onChange("description", html)}
//           placeholder="Write details about this event…"
//           minHeight={260}
//         />
//       </Section>

//       {/* VENUE */}
//       <Section
//         title="Venue"
//         subtitle="Where the event is hosted"
//       >
//         <div className={AD.formGrid2}>
//           {Object.keys(form.venue)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={k.charAt(0).toUpperCase() + k.slice(1)}
//                 value={form.venue[k]}
//                 onChange={(v) => onNestedChange("venue", k, v)}
//                 type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
//               />
//             ))}
//         </div>

//         {/* logo upload */}
//         <div className="mt-2">
//           <Label>Venue Logo</Label>
//           <UploadRow
//             inputId="venue-logo-upload"
//             onFile={handleVenueLogoFile}
//             progress={uploadProgress["venue"]}
//             value={form.venue.logoUrl}
//             onChange={(v) => onNestedChange("venue", "logoUrl", v)}
//           />
//           {form.venue.logoUrl && <Thumb src={form.venue.logoUrl} alt="Venue Logo" />}
//         </div>
//       </Section>

//       {/* TICKET CATEGORIES */}
//       <Section
//         title="Ticket Categories"
//         subtitle="Configure pricing, inventory and perks"
//       >
//         {form.ticketCategories.map((t, i) => {
//           const disabled = !t.isTicketAvailable; // NEW
//           return (
//             <div key={i} className="border p-4 my-2 rounded-2xl bg-white shadow-sm hover:shadow-md transition">
//               <div className={AD.formGrid2}>
//                 <Input label="Type" value={t.type} onChange={(v) => onArrayChange("ticketCategories", i, "type", v)} />
//                 <Input label="Price" type="number" value={t.price} onChange={(v) => onArrayChange("ticketCategories", i, "price", v)} disabled={disabled} />
//                 <Input label="Currency" value={t.currency} onChange={(v) => onArrayChange("ticketCategories", i, "currency", v)} disabled={disabled} />
//                 <Input label="Total Seats" type="number" value={t.totalSeats} onChange={(v) => onArrayChange("ticketCategories", i, "totalSeats", v)} disabled={disabled} />
//                 <Input label="Available Seats" type="number" value={t.availableSeats} onChange={(v) => onArrayChange("ticketCategories", i, "availableSeats", v)} disabled={disabled} />
//               </div>

//               {/* NEW: Availability toggle */}
//               <div className="mt-3 grid sm:grid-cols-2 gap-3">
//                 <Toggle
//                   label="Tickets Available"
//                   checked={!!t.isTicketAvailable}
//                   onChange={(v) => onArrayChange("ticketCategories", i, "isTicketAvailable", v)}
//                 />
//               </div>

//               <div className="mt-4">
//                 <Label>Perks</Label>
//                 {t.perks.map((perk, j) => (
//                   <div key={j} className="flex items-center gap-2 mb-2">
//                     <input
//                       className={baseInput}
//                       value={perk}
//                       onChange={(e) => {
//                         const updated = [...t.perks];
//                         updated[j] = e.target.value;
//                         onArrayChange("ticketCategories", i, "perks", updated);
//                       }}
//                       placeholder="Add a perk…"
//                       disabled={disabled}
//                     />
//                     <IconButton aria="Remove perk" onClick={() => {
//                       const updated = t.perks.filter((_, idx) => idx !== j);
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}>
//                       <FaTrash />
//                     </IconButton>
//                   </div>
//                 ))}
//                 <GhostButton onClick={() => onArrayChange("ticketCategories", i, "perks", [...t.perks, ""])}>
//                   <FaPlus /> Add Perk
//                 </GhostButton>
//               </div>

//               <div className="mt-3">
//                 <DangerLink onClick={() => removeArrayItem("ticketCategories", i)}>
//                   <FaTrash /> Remove Ticket
//                 </DangerLink>
//               </div>
//             </div>
//           );
//         })}


//         <PrimaryButton
//           type="button"
//           className="mt-2"
//           onClick={() =>
//             addArrayItem("ticketCategories", {
//               type: "",
//               price: "",
//               currency: "INR",
//               totalSeats: "",
//               availableSeats: "",
//               perks: [""],
//               isTicketAvailable: true, // NEW
//             })
//           }
//         >
//           <FaPlus /> Add Ticket
//         </PrimaryButton>
//       </Section>

//       {/* SHOWTIMES */}
//       <Section
//         title="Showtimes"
//         subtitle="Add one or more schedules with pricing"
//       >
//         {form.showtimes.map((s, i) => (
//           <div key={i} className="border p-4 my-2 rounded-2xl bg-white shadow-sm hover:shadow-md transition">
//             <div className={AD.formGrid2}>
//               <Input label="Start Time" type="datetime-local" value={s.startTime} onChange={(v) => onArrayChange("showtimes", i, "startTime", v)} />
//               <Input label="End Time" type="datetime-local" value={s.endTime} onChange={(v) => onArrayChange("showtimes", i, "endTime", v)} />
//               <Input label="Available Seats" type="number" value={s.availableSeats} onChange={(v) => onArrayChange("showtimes", i, "availableSeats", v)} />
//               <Input label="Ticket Price" type="number" value={s.ticketPrice} onChange={(v) => onArrayChange("showtimes", i, "ticketPrice", v)} />
//             </div>
//             <div className="mt-3">
//               <DangerLink onClick={() => removeArrayItem("showtimes", i)}>
//                 <FaTrash /> Remove Showtime
//               </DangerLink>
//             </div>
//           </div>
//         ))}

//         <PrimaryButton
//           type="button"
//           onClick={() =>
//             addArrayItem("showtimes", {
//               startTime: "",
//               endTime: "",
//               availableSeats: "",
//               ticketPrice: "",
//             })
//           }
//         >
//           <FaPlus /> Add Showtime
//         </PrimaryButton>
//       </Section>

//       {/* IMAGES */}
//       <Section
//         title="Images"
//         subtitle="Poster and landscape gallery"
//       >
//         {/* Poster */}
//         <div>
//           <Label>Poster Image</Label>
//           <div className="border-2 border-dashed rounded-2xl p-4 text-center bg-white">
//             <input type="file" accept="image/*" className="hidden" id="poster-upload" onChange={handlePosterFile} />
//             <label htmlFor="poster-upload" className="cursor-pointer text-amber-700 hover:underline">
//               {uploadProgress["poster"] ? <span className="inline-flex items-center gap-2"><FaSpinner className="animate-spin" /> Uploading…</span> : "Choose or drag a poster image"}
//             </label>
//             {uploadProgress["poster"] ? (
//               <div className="mt-3 h-1.5 rounded bg-slate-100">
//                 <div className="h-1.5 rounded bg-amber-400" style={{ width: `${uploadProgress["poster"]}%` }} />
//               </div>
//             ) : null}
//           </div>
//           {form.imageUrl && <Thumb src={form.imageUrl} alt="Poster Preview" large />}
//         </div>

//         {/* Landscape */}
//         <div className="mt-4">
//           <Label>Landscape Images</Label>
//           {form.landsacpImage.map((img, i) => (
//             <div key={i} className="mb-3">
//               <UploadRow
//                 inputId={`landscape-upload-${i}`}
//                 onFile={(e) => handleLandscapeFile(e, i)}
//                 progress={uploadProgress[`landscape-${i}`]}
//                 value={img}
//                 onChange={(v) => {
//                   const imgs = [...form.landsacpImage];
//                   imgs[i] = v;
//                   onChange("landsacpImage", imgs);
//                 }}
//               />
//               <div className="mt-2 flex items-center gap-2">
//                 <IconButton aria="Remove image" onClick={() => removeArrayItem("landsacpImage", i)}>
//                   <FaTrash />
//                 </IconButton>
//                 {img && <Thumb src={img} alt={`Landscape ${i + 1}`} />}
//               </div>
//             </div>
//           ))}
//           <GhostButton onClick={() => onChange("landsacpImage", [...form.landsacpImage, ""])}>
//             <FaPlus /> Add Landscape Image
//           </GhostButton>
//         </div>
//       </Section>

//       {/* ORGANIZER */}
//       <Section
//         title="Organizer"
//         subtitle="Public information for event host"
//       >
//         <div className={AD.formGrid2}>
//           {Object.keys(form.organizer)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={k.charAt(0).toUpperCase() + k.slice(1)}
//                 value={form.organizer[k]}
//                 onChange={(v) => onNestedChange("organizer", k, v)}
//                 type={k === "contactEmail" ? "email" : k === "contactPhone" ? "tel" : "text"}
//               />
//             ))}
//         </div>

//         <div className="mt-2">
//           <Label>Organizer Logo</Label>
//           <UploadRow
//             inputId="organizer-logo-upload"
//             onFile={handleOrganizerLogoFile}
//             progress={uploadProgress["organizer"]}
//             value={form.organizer.logoUrl}
//             onChange={(v) => onNestedChange("organizer", "logoUrl", v)}
//           />
//           {form.organizer.logoUrl && <Thumb src={form.organizer.logoUrl} alt="Organizer Logo" />}
//         </div>
//       </Section>

//       {/* SPONSORS */}
//       <Section
//         title="Sponsors"
//         subtitle="Show appreciation and manage branding"
//       >
//         {form.sponsors.map((s, i) => (
//           <div key={i} className="border p-4 my-2 rounded-2xl bg-white shadow-sm hover:shadow-md transition">
//             <div className={AD.formGrid2}>
//               <Input label="Name" value={s.name} onChange={(v) => onArrayChange("sponsors", i, "name", v)} />
//               <Select
//                 label="Type"
//                 value={s.type}
//                 options={[
//                   "Title Sponsor", "Presenting Sponsor", "Powered By Sponsor", "Associate Sponsor", "Official Partner",
//                   "Official Beverage Partner", "Official Food Partner", "Official Travel Partner", "Official Airline Partner",
//                   "Official Transport Partner", "Official Hotel Partner", "Official Hospitality Partner", "Official Bank Partner",
//                   "Official Insurance Partner", "Official Payment Partner", "Official Apparel Partner", "Official Footwear Partner",
//                   "Official Merchandise Partner", "Official Electronics Partner", "Official Technology Partner", "Official Streaming Partner",
//                   "Official Ticketing Partner", "Official Education Partner", "Official Telecom Partner", "Venue Partner", "Logistics Partner",
//                   "Stage & Equipment Partner", "Printing Partner", "Security Partner", "Decoration Partner", "Photography Partner",
//                   "Medical Partner", "Gifts Partner", "Print Media Partner", "TV Media Partner", "Radio Partner", "Digital Media Partner",
//                   "Outdoor Media Partner", "Social Media Partner", "Accommodation Partner", "Catering Partner", "Food & Beverage Partner",
//                   "Lounge Partner", "App Partner", "WiFi Partner", "Virtual Event Partner", "AR/VR Partner", "Gaming Partner",
//                   "NGO Partner", "Environmental Partner", "Government Partner", "Cultural Partner"
//                 ]}
//                 onChange={(v) => onArrayChange("sponsors", i, "type", v)}
//               />
//             </div>

//             <Textarea label="Description" value={s.description} onChange={(v) => onArrayChange("sponsors", i, "description", v)} />

//             <div className="mt-2">
//               <Label>Logo</Label>
//               <UploadRow
//                 inputId={`sponsor-logo-upload-${i}`}
//                 onFile={(e) => handleSponsorLogoFile(e, i)}
//                 progress={uploadProgress[`sponsor-${i}`]}
//                 value={s.logo}
//                 onChange={(v) => onArrayChange("sponsors", i, "logo", v)}
//               />
//               {s.logo && <Thumb src={s.logo} alt={`Sponsor ${i + 1} logo`} />}
//             </div>

//             <div className="mt-3">
//               <DangerLink onClick={() => removeArrayItem("sponsors", i)}>
//                 <FaTrash /> Remove Sponsor
//               </DangerLink>
//             </div>
//           </div>
//         ))}

//         <PrimaryButton
//           type="button"
//           onClick={() =>
//             addArrayItem("sponsors", {
//               name: "",
//               logo: "",
//               description: "",
//               type: "Title Sponsor",
//             })
//           }
//         >
//           <FaPlus /> Add Sponsor
//         </PrimaryButton>
//       </Section>

//       {/* TERMS */}
//       <Section title="Terms & Conditions" subtitle="Add points visible on the event page">
//         {form.termsAndConditions.map((t, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className={baseInput}
//               placeholder="Write a point…"
//               value={t.point}
//               onChange={(e) => onArrayChange("termsAndConditions", i, "point", e.target.value)}
//             />
//             <IconButton aria="Remove term" onClick={() => removeArrayItem("termsAndConditions", i)}>
//               <FaTrash />
//             </IconButton>
//           </div>
//         ))}
//         <GhostButton onClick={() => addArrayItem("termsAndConditions", { point: "" })}>
//           <FaPlus /> Add Point
//         </GhostButton>
//       </Section>

//       {/* TAGS */}
//       <Section title="Tags" subtitle="Improve discoverability with keywords">
//         {form.tags.map((tag, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className={baseInput}
//               placeholder="Add a tag…"
//               value={tag}
//               onChange={(e) => {
//                 const updated = [...form.tags];
//                 updated[i] = e.target.value;
//                 onChange("tags", updated);
//               }}
//             />
//             <IconButton aria="Remove tag" onClick={() => removeArrayItem("tags", i)}>
//               <FaTrash />
//             </IconButton>
//           </div>
//         ))}
//         <GhostButton onClick={() => onChange("tags", [...form.tags, ""])}>
//           <FaPlus /> Add Tag
//         </GhostButton>
//       </Section>

//       {/* OTHER */}
//       <Section title="Other Details" subtitle="Operational details and flags">
//         <div className={AD.formGrid2}>
//           <Select label="Status" value={form.status} onChange={(v) => onChange("status", v)} options={["Upcoming", "Live"]} />
//           <Input label="Remark" value={form.remark} onChange={(v) => onChange("remark", v)} />
//           <Input label="Age Restriction" type="number" value={form.ageRestriction} onChange={(v) => onChange("ageRestriction", v)} />
//           <Input label="Duration (minutes)" type="number" value={form.duration} onChange={(v) => onChange("duration", v)} />
//           <Input label="Average Rating" type="number" step="0.1" min="0" max="5" value={form.ratings.averageRating} onChange={(v) => onNestedChange("ratings", "averageRating", v)} />
//           <Input label="Total Reviews" type="number" min="0" value={form.ratings.totalReviews} onChange={(v) => onNestedChange("ratings", "totalReviews", v)} />
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4">
//           <Toggle label="Premium" checked={form.isVerified} onChange={(v) => onChange("isVerified", v)} />
//           <Toggle label="Booking Open" checked={form.isBookingOpen} onChange={(v) => onChange("isBookingOpen", v)} />
//           <Toggle label="Active" checked={form.isActived} onChange={(v) => onChange("isActived", v)} />
//         </div>
//       </Section>

//       {/* footer actions (sticky on mobile feel) */}
//       <div className="flex items-center justify-end gap-2 pt-2">
//         <Link
//           to={`/admin/events/view/${id}`}
//           className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-slate-700 hover:bg-slate-50"
//         >
//           <FaPlus className="opacity-70" />
//           Back to View
//         </Link>
//         <PrimaryButton type="submit" disabled={loading}>
//           {loading ? <><FaSpinner className="animate-spin" /> Updating…</> : "Update Event"}
//         </PrimaryButton>
//       </div>
//     </form>
//   );
// }

// /* =========================================================
//    Reusable UI — polished components
// ========================================================= */

// const Section = ({ title, children, subtitle, icon }) => (
//   <div className="p-6 border rounded-2xl bg-white shadow-sm hover:shadow-md transition-shadow">
//     <div className="flex items-start gap-3 mb-4">
//       {icon ? <div className="text-amber-500 mt-0.5">{icon}</div> : null}
//       <div>
//         <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
//         {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
//       </div>
//     </div>
//     <div className="space-y-4">{children}</div>
//   </div>
// );

// const Label = ({ children }) => (
//   <label className="block text-sm font-medium text-slate-700">{children}</label>
// );

// const baseInput =
//   "mt-1 w-full rounded-xl border bg-white/90 px-3 py-2.5 outline-none " +
//   "focus:ring-2 focus:ring-amber-300 focus:border-amber-300 " +
//   "placeholder:text-slate-400 transition";

// const Input = ({ label, value, onChange, type = "text", required = false, placeholder, hint, step, min, max, disabled }) => (
//   <div>
//     {label && <Label>{label}</Label>}
//     <input
//       type={type}
//       className={`${baseInput} ${disabled ? "bg-slate-100 cursor-not-allowed" : ""}`}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       required={required}
//       placeholder={placeholder}
//       step={step}
//       min={min}
//       max={max}
//       aria-label={label}
//       disabled={disabled}
//     />
//     {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
//   </div>
// );

// const Textarea = ({ label, value, onChange, rows = 4, placeholder }) => (
//   <div>
//     {label && <Label>{label}</Label>}
//     <textarea
//       className={`${baseInput} min-h-[120px]`}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       rows={rows}
//       placeholder={placeholder}
//       aria-label={label}
//     />
//   </div>
// );

// const Select = ({ label, value, onChange, options, disabled }) => (
//   <div>
//     {label && <Label>{label}</Label>}
//     <select
//       className={`${baseInput} pr-9 ${disabled ? "bg-slate-100 cursor-not-allowed" : ""}`}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       aria-label={label}
//       disabled={disabled}
//     >
//       {options.map((opt) => (
//         <option key={opt} value={opt}>
//           {opt}
//         </option>
//       ))}
//     </select>
//   </div>
// );

// /* Buttons */

// const PrimaryButton = ({ children, className = "", ...props }) => (
//   <button
//     className={`inline-flex items-center gap-2 rounded-full bg-amber-400 px-5 py-2 font-semibold text-slate-900 shadow-sm hover:bg-amber-300 disabled:opacity-60 ${className}`}
//     {...props}
//   >
//     {children}
//   </button>
// );

// const GhostButton = ({ children, className = "", ...props }) => (
//   <button
//     type="button"
//     className={`inline-flex items-center gap-2 text-amber-700 hover:underline text-sm ${className}`}
//     {...props}
//   >
//     {children}
//   </button>
// );

// const DangerLink = ({ children, className = "", ...props }) => (
//   <button
//     type="button"
//     className={`inline-flex items-center gap-2 text-red-600 hover:underline text-sm ${className}`}
//     {...props}
//   >
//     {children}
//   </button>
// );

// const IconButton = ({ children, aria, className = "", ...props }) => (
//   <button
//     type="button"
//     aria-label={aria}
//     className={`inline-flex h-10 w-10 items-center justify-center rounded-lg border bg-white text-slate-600 hover:bg-slate-50 ${className}`}
//     {...props}
//   >
//     {children}
//   </button>
// );

// /* Toggle */

// const Toggle = ({ checked, onChange, label }) => (
//   <label className="flex items-center justify-between gap-3 rounded-xl border px-3 py-2 bg-white">
//     <span className="text-sm font-medium text-slate-800">{label}</span>
//     <button
//       type="button"
//       onClick={() => onChange(!checked)}
//       className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${checked ? "bg-emerald-500" : "bg-slate-300"}`}
//       aria-pressed={checked}
//     >
//       <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${checked ? "translate-x-5" : "translate-x-1"}`} />
//     </button>
//   </label>
// );

// /* Upload */

// const UploadRow = ({ inputId, onFile, progress, value, onChange, placeholder = "Paste image URL (optional)" }) => (
//   <div className="flex flex-col md:flex-row gap-2">
//     <input
//       className={baseInput}
//       placeholder={placeholder}
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//     />
//     <div className="border-2 border-dashed rounded-xl p-2 text-center">
//       <input type="file" accept="image/*" className="hidden" id={inputId} onChange={onFile} />
//       <label htmlFor={inputId} className="cursor-pointer text-amber-700 hover:underline">
//         Choose or drag file
//       </label>
//     </div>
//     {typeof progress === "number" ? (
//       <div className="min-w-[140px] self-center text-xs text-slate-500">
//         {progress < 100 ? "Uploading…" : "Done"}
//         <div className="mt-1 h-1.5 rounded bg-slate-100">
//           <div className="h-1.5 rounded bg-amber-400" style={{ width: `${progress}%` }} />
//         </div>
//       </div>
//     ) : null}
//   </div>
// );

// const Thumb = ({ src, alt = "Preview", large = false }) => (
//   <div className="mt-3 flex items-center gap-3">
//     <img
//       src={src}
//       alt={alt}
//       className={`${large ? "h-40 w-40" : "h-16 w-16"} rounded-xl border object-cover`}
//       onError={(e) => (e.currentTarget.src = "https://via.placeholder.com/150?text=Image")}
//     />
//     <p className="break-all text-xs text-slate-500">{src}</p>
//   </div>
// );


import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { get, post, put } from "../../../lib/http";
import { API } from "../../../config/api";
import {
  FaPlus,
  FaTrash,
  FaSpinner,
  FaCheckCircle,
  FaTimesCircle,
  FaSearch,
  FaCrosshairs,
  FaMapMarkerAlt,
} from "react-icons/fa";
import RichText from "./RichText";
import { AD, focusAdminField } from "../../adminUi.js";
import { imgErrorFallback } from "../../../lib/placeholder.js";

const cn = (...a) => a.filter(Boolean).join(" ");

/* ---------- helpers ---------- */

/** Match stored UTC wall-clock (same face as admin datetime-local). */
function formatDateTimeForInput(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d)) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(
    d.getUTCHours()
  )}:${pad(d.getUTCMinutes())}`;
}

/** datetime-local → ISO keeping entered clock time (no IST offset). */
function dateTimeLocalToStoredIso(localStr) {
  if (!localStr) return "";
  const m = String(localStr).match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/
  );
  if (!m) return localStr;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const day = Number(m[3]);
  const h = Number(m[4]);
  const mi = Number(m[5]);
  return new Date(Date.UTC(y, mo - 1, day, h, mi)).toISOString();
}

/** datetime-local min/max from a local Date (browser calendar). */
const toDTLocal = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};

/* ===== Free geocoding: OpenStreetMap Nominatim (no key, free) ===== */

const NOMINATIM_BASE = "https://nominatim.openstreetmap.org";

function useDebouncedValue(value, ms = 300) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

async function nominatimSearch(q, { limit = 6, lang = "en" } = {}) {
  if (!q?.trim()) return [];
  const url = `${NOMINATIM_BASE}/search?format=jsonv2&q=${encodeURIComponent(
    q
  )}&addressdetails=1&limit=${limit}&accept-language=${encodeURIComponent(lang)}`;
  const res = await fetch(url, { headers: { Accept: "application/json" } });
  if (!res.ok) throw new Error("Search failed");
  return res.json();
}

async function nominatimReverse(lat, lon, { lang = "en" } = {}) {
  const url = `${NOMINATIM_BASE}/reverse?format=jsonv2&lat=${encodeURIComponent(
    lat
  )}&lon=${encodeURIComponent(lon)}&addressdetails=1&accept-language=${encodeURIComponent(lang)}`;
  const res = await fetch(url, { headers: { Accept: "application/json" } });
  if (!res.ok) throw new Error("Reverse failed");
  return res.json();
}

function normalizeAddress(osm) {
  const a = osm?.address || {};
  const city = a.city || a.town || a.village || a.hamlet || "";
  const state = a.state || a.region || "";
  const country = a.country || "";
  const pincode = a.postcode || "";
  const name = a.neighbourhood || a.suburb || a.quarter || a.road || a.residential || "";
  const address = osm?.display_name || "";
  return {
    name,
    address,
    city,
    state,
    country,
    pincode,
    latitude: String(osm?.lat || ""),
    longitude: String(osm?.lon || ""),
  };
}

/* =========================================================
   MAIN
========================================================= */

export default function AdminEventEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    category: "Music",
    description: "",
    venue: {
      name: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      latitude: "",
      longitude: "",
      capacity: "",
      logoUrl: ""
    },
    date: "",
    ticketCategories: [
      {
        type: "",
        price: "",
        currency: "INR",
        totalSeats: "",
        availableSeats: "",
        perks: [""],
        isTicketAvailable: true, // NEW
      },
    ],
    showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
    imageUrl: "",
    landsacpImage: [""],
    layoutImage: "",
    status: "Upcoming",
    organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
    termsAndConditions: [{ point: "" }],
    ratings: { averageRating: 0, totalReviews: 0 },
    isVerified: false,
    isBookingOpen: true,
    isActived: true,
    remark: "",
    tags: [""],
    sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
    ageRestriction: "",
    language: "",
    duration: "",
    gstRateRaw: "",                // raw shown in UI (percent like "18")
    gstRate: "",                   // processed numeric (0.18)
    conveniencesFeeType: "convenienceFeeFlat", // selected option
    conveniencesFeeValueRaw: "",   // raw shown in UI (like "50" or "10")
    convenienceFeeFlat: "",       // processed if flat (numeric)
    convenienceFeePercent: ""
  });

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [uploadProgress, setUploadProgress] = useState({});

  const now = new Date();
  const startOfTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
  const minEventDate = toDTLocal(startOfTomorrow);

  const onFormChange = (key, value) => {
    setForm((prev) => {
      const updated = { ...prev };

      // GST
      if (key === "gstRate") {
        updated.gstRateRaw = value === "" ? "" : value;
        const n = parseFloat(value);
        updated.gstRate = !isNaN(n) && value !== "" ? n / 100 : "";
        return updated;
      }

      // conveniences fee type changed
      if (key === "conveniencesFeeType") {
        const newType = value;
        // keep raw value if exists
        const raw = prev.conveniencesFeeValueRaw ?? "";

        updated.conveniencesFeeType = newType;
        updated.conveniencesFeeValueRaw = raw;

        const parsed = parseFloat(raw);
        if (newType === "convenienceFeePercent") {
          updated.convenienceFeePercent =
            !isNaN(parsed) && raw !== "" ? parsed / 100 : "";
          updated.convenienceFeeFlat = "";
        } else {
          updated.convenienceFeeFlat =
            !isNaN(parsed) && raw !== "" ? parsed : "";
          updated.convenienceFeePercent = "";
        }
        return updated;
      }

      // unified conveniences fee value input
      if (key === "conveniencesFeeValue") {
        updated.conveniencesFeeValueRaw = value === "" ? "" : value;
        const parsed = parseFloat(value);
        if (prev.conveniencesFeeType === "convenienceFeePercent") {
          updated.convenienceFeePercent =
            !isNaN(parsed) && value !== "" ? parsed / 100 : "";
          updated.convenienceFeeFlat = "";
        } else {
          updated.convenienceFeeFlat =
            !isNaN(parsed) && value !== "" ? parsed : "";
          updated.convenienceFeePercent = "";
        }
        return updated;
      }

      // optional: support direct keys if you used them
      if (key === "convenienceFeePercent") {
        updated.conveniencesFeeValueRaw = value === "" ? "" : value;
        const parsed = parseFloat(value);
        updated.convenienceFeePercent =
          !isNaN(parsed) && value !== "" ? parsed / 100 : "";
        updated.convenienceFeeFlat = "";
        return updated;
      }
      if (key === "convenienceFeeFlat") {
        updated.conveniencesFeeValueRaw = value === "" ? "" : value;
        const parsed = parseFloat(value);
        updated.convenienceFeeFlat =
          !isNaN(parsed) && value !== "" ? parsed : "";
        updated.convenienceFeePercent = "";
        return updated;
      }

      // fallback
      updated[key] = value;
      return updated;
    });
  };


  /* ---------- fetch existing event ---------- */
  useEffect(() => {
    let isMounted = true;
    const fetchEvent = async () => {
      try {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const res = await get(`${API.events.getSinglEvent}/${id}`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        });
        if (isMounted) {
          setForm({
            name: res.event.name || "",
            category: res.event.category || "Music",
            description: res.event.description || "",
            venue: {
              name: res.event.venue?.name || "",
              address: res.event.venue?.address || "",
              city: res.event.venue?.city || "",
              state: res.event.venue?.state || "",
              country: res.event.venue?.country || "",
              pincode: res.event.venue?.pincode || "",
              latitude: res.event.venue?.latitude || "",
              longitude: res.event.venue?.longitude || "",
              capacity: res.event.venue?.capacity || "",
              logoUrl: res.event.venue?.logoUrl || "",
            },
            date: formatDateTimeForInput(res.event.date) || "",
            ticketCategories:
              res.event.ticketCategories?.length > 0
                ? res.event.ticketCategories.map((t) => ({
                  ...t,
                  isTicketAvailable: t?.isTicketAvailable ?? true,
                  perks: Array.isArray(t?.perks) ? t.perks : [""],
                }))
                : [{
                  type: "",
                  price: "",
                  currency: "INR",
                  totalSeats: "",
                  availableSeats: "",
                  perks: [""],
                  isTicketAvailable: true,
                }],
            showtimes:
              res.event.showtimes?.length > 0
                ? res.event.showtimes.map((s) => ({
                  startTime: formatDateTimeForInput(s.startTime),
                  endTime: formatDateTimeForInput(s.endTime),
                  availableSeats: s.availableSeats || "",
                  ticketPrice: s.ticketPrice || "",
                }))
                : [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
            imageUrl: res.event.imageUrl || "",
            landsacpImage: res.event.landsacpImage?.length > 0 ? res.event.landsacpImage : [""],
            status: res.event.status || "Upcoming",
            organizer: {
              name: res.event.organizer?.name || "",
              contactEmail: res.event.organizer?.contactEmail || "",
              contactPhone: res.event.organizer?.contactPhone || "",
              website: res.event.organizer?.website || "",
              logoUrl: res.event.organizer?.logoUrl || "",
            },
            termsAndConditions:
              res.event.termsAndConditions?.length > 0
                ? res.event.termsAndConditions
                : [{ point: "" }],
            ratings: {
              averageRating: res.event.ratings?.averageRating || 0,
              totalReviews: res.event.ratings?.totalReviews || 0,
            },
            isVerified: res.event.isVerified || false,
            isBookingOpen: res.event.isBookingOpen || false,
            isActived: res.event.isActived ?? true,
            remark: res.event.remark || "",
            tags: res.event.tags?.length > 0 ? res.event.tags : [""],
            sponsors:
              res.event.sponsors?.length > 0
                ? res.event.sponsors
                : [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
            ageRestriction: res.event.ageRestriction || "",
            language: res.event.language || "",
            duration: res.event.duration || "",
            gstRate: res.event.gstRate,
            convenienceFeeFlat: res.event.convenienceFeeFlat || '',
            convenienceFeePercent: res.event.convenienceFeePercent || '',
            conveniencesFeeType: res.event.conveniencesFeeType

          });
        }
      } catch (err) {
        if (isMounted) setMessage("❌ Failed to load event details.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    fetchEvent();
    return () => {
      isMounted = false;
    };
  }, [id]);

  /* ---------- state helpers ---------- */
  const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
  const onNestedChange = (parent, key, value) =>
    setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));
  const onArrayChange = (arrKey, index, key, value) => {
    const updated = [...form[arrKey]];
    updated[index][key] = value;
    setForm((f) => ({ ...f, [arrKey]: updated }));
  };

  const addArrayItem = (arrKey, newItem) =>
    setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
  const removeArrayItem = (arrKey, index) =>
    setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

  /* ---------- upload ---------- */
  const uploadFileAndGetUrl = async (file, key = null) => {
    if (!file) return "";
    const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
    const fd = new FormData();
    fd.append("file", file);
    setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 0 }));
    const resp = await post(API.events.fileUploader, fd, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    setUploadProgress((p) => ({ ...p, [key ?? "poster"]: 100 }));

    if (!resp.success) {
      throw new Error(resp?.message || "Upload failed");
    }
    const url =
      resp?.url ||
      resp?.resp?.url ||
      resp?.fileUrl ||
      resp?.location ||
      resp?.path ||
      resp?.secure_url ||
      "";
    if (!url) throw new Error("Upload success but no URL found in response.");
    return url;
  };

  const handlePosterFile = async (e) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;
      setMessage("Uploading poster...");
      const url = await uploadFileAndGetUrl(file, "poster");
      onChange("imageUrl", url);
      setMessage("✅ Poster uploaded.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Poster upload failed.");
    }
  };

  const handleLayoutImageFile = async (e) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;
      setMessage("Uploading layout image...");
      const url = await uploadFileAndGetUrl(file, "layout"); // progress key: "layout"
      onChange("layoutImage", url);
      setMessage("✅ Layout image uploaded.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Layout image upload failed.");
    }
  };


  const handleLandscapeFile = async (e, index) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;
      setMessage(`Uploading landscape image ${index + 1}...`);
      const url = await uploadFileAndGetUrl(file, `landscape-${index}`);
      const imgs = [...form.landsacpImage];
      imgs[index] = url;
      onChange("landsacpImage", imgs);
      setMessage("✅ Landscape image uploaded.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Landscape upload failed.");
    }
  };

  const handleSponsorLogoFile = async (e, index) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;
      setMessage(`Uploading sponsor ${index + 1} logo...`);
      const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
      onArrayChange("sponsors", index, "logo", url);
      setMessage("✅ Sponsor logo uploaded.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Sponsor logo upload failed.");
    }
  };

  const handleOrganizerLogoFile = async (e) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;
      setMessage("Uploading organizer logo...");
      const url = await uploadFileAndGetUrl(file, "organizer");
      onNestedChange("organizer", "logoUrl", url);
      setMessage("✅ Organizer logo uploaded.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Organizer logo upload failed.");
    }
  };

  const handleVenueLogoFile = async (e) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;
      setMessage("Uploading venue logo...");
      const url = await uploadFileAndGetUrl(file, "venue");
      onNestedChange("venue", "logoUrl", url);
      setMessage("✅ Venue logo uploaded.");
    } catch (err) {
      console.error(err);
      setMessage("❌ Venue logo upload failed.");
    }
  };

  /* ---------- submit ---------- */
  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      const payload = {
        ...form,
        date: dateTimeLocalToStoredIso(form.date),
        showtimes: (form.showtimes || []).map((s) => ({
          ...s,
          startTime: dateTimeLocalToStoredIso(s.startTime),
          endTime: dateTimeLocalToStoredIso(s.endTime),
        })),
      };
      await put(`${API.events.editEvent}/${id}`, payload, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      });
      setMessage("✅ Event updated successfully!");
      setTimeout(() => navigate("/admin/events"), 1200);
    } catch (err) {
      console.error(err);
      setMessage("❌ Failed to update event.");
    } finally {
      setLoading(false);
    }
  };

  /* ---------- loading skeleton ---------- */
  if (loading) {
    return (
      <div className={AD.formWrapWide}>
        <div className={cn(AD.formSurface, "animate-pulse")}>
          <div className="h-8 w-1/3 bg-gray-200 rounded-lg mb-6" />
          <div className="space-y-4">
            <div className="h-6 w-1/2 bg-gray-200 rounded-lg" />
            <div className="h-6 w-3/4 bg-gray-200 rounded-lg" />
            <div className="h-6 w-1/4 bg-gray-200 rounded-lg" />
          </div>
        </div>
      </div>
    );
  }

  /* ---------- UI ---------- */
  return (
    <form onSubmit={onSubmit} className={cn(AD.formWrapWide, AD.formSurfaceMuted, "space-y-6")}>
      {/* header */}
      <div className={cn(AD.formHeader, "sm:items-center")}>
        <div>
          <h1 className={AD.title}>Edit event</h1>
          <p className={AD.subtitle}>Update details and save changes.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Link to={`/admin/events/view/${id}`} className={cn(AD.btnSecondary, "inline-flex items-center gap-2")}>
            <FaPlus className="opacity-70" />
            Back to view
          </Link>
          <PrimaryButton type="submit" disabled={loading}>
            {loading ? <><FaSpinner className="animate-spin" /> Updating…</> : "Update Event"}
          </PrimaryButton>
        </div>
      </div>

      {message && (
        <div className={`flex items-center gap-2 text-sm ${message.includes("✅") ? "text-emerald-700" : "text-red-600"}`}>
          {message.includes("✅") ? <FaCheckCircle /> : <FaTimesCircle />}
          {message}
        </div>
      )}

      {/* BASIC INFO */}
      <Section
        title="Basic Info"
        subtitle="Core information visible to customers"
      >
        <div className={AD.formGrid2}>
          <Input label="Event Name" field="name" value={form.name} onChange={(v) => onChange("name", v)} required />
          <Select
            label="Category"
            value={form.category}
            onChange={(v) => onChange("category", v)}
            options={[
              "Music",
              "Theatre",
              "Comedy",
              "Dance",
              "Sports",
              "Exhibition",
              "Festival",
              "Conference",
              "Workshop",
              "Other",
            ]}
          />
          <Input
            label="Event Date"
            field="date"
            type="datetime-local"
            value={form.date}
            onChange={(v) => {
              const picked = new Date(v);
              if (picked < startOfTomorrow) {
                setMessage("❌ Event Date must be after today.");
                focusAdminField("date");
                return;
              }
              onChange("date", v);
            }}
            required
            min={minEventDate}
            hint="Must be in the future"
          />
          <Input label="Language" value={form.language} onChange={(v) => onChange("language", v)} />
        </div>

        <RichText
          label="Description"
          value={form.description}
          onChange={(html) => onChange("description", html)}
          placeholder="Write details about this event…"
          minHeight={260}
        />
      </Section>

      {/* VENUE */}
      <Section title="Venue" subtitle="Search address or use current location (free via OpenStreetMap)">
        {/* NEW: Address Picker */}
        <AddressPicker
          value={form.venue}
          onPick={(patch) => {
            Object.entries(patch).forEach(([k, v]) => onNestedChange("venue", k, v ?? ""));
          }}
        />

        <div className={AD.formGrid2}>
          {Object.keys(form.venue)
            .filter((k) => k !== "logoUrl")
            .map((k) => (
              <Input
                key={k}
                label={k.charAt(0).toUpperCase() + k.slice(1)}
                field={`venue.${k}`}
                value={form.venue[k]}
                onChange={(v) => onNestedChange("venue", k, v)}
                type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
              />
            ))}
        </div>

        {/* logo upload */}
        <div className="mt-2">
          <Label>Venue Logo</Label>
          <UploadRow
            inputId="venue-logo-upload"
            onFile={handleVenueLogoFile}
            progress={uploadProgress["venue"]}
            value={form.venue.logoUrl}
            onChange={(v) => onNestedChange("venue", "logoUrl", v)}
          />
          {form.venue.logoUrl && <Thumb src={form.venue.logoUrl} alt="Venue Logo" />}
        </div>
      </Section>

      {/* TICKET CATEGORIES */}
      <Section
        title="Ticket Categories"
        subtitle="Configure pricing, inventory and perks"
      >
        {form.ticketCategories.map((t, i) => {
          const disabled = !t.isTicketAvailable;
          return (
            <div
              key={i}
              className="my-2 rounded-2xl border border-slate-200/90 bg-white p-4 shadow-sm transition hover:shadow-md dark:border-gray-800 dark:bg-gray-900"
              data-admin-field={i === 0 ? "ticketCategories" : undefined}
              tabIndex={i === 0 ? -1 : undefined}
            >
              <div className={AD.formGrid2}>
                <Input label="Type" value={t.type} onChange={(v) => onArrayChange("ticketCategories", i, "type", v)} />
                <Input label="Price" type="number" value={t.price} onChange={(v) => onArrayChange("ticketCategories", i, "price", v)} disabled={disabled} />
                <Input label="Currency" value={t.currency} onChange={(v) => onArrayChange("ticketCategories", i, "currency", v)} disabled={disabled} />
                <Input label="Total Seats" type="number" value={t.totalSeats} onChange={(v) => onArrayChange("ticketCategories", i, "totalSeats", v)} disabled={disabled} />
                <Input label="Available Seats" type="number" value={t.availableSeats} onChange={(v) => onArrayChange("ticketCategories", i, "availableSeats", v)} disabled={disabled} />
              </div>

              {/* Availability toggle */}
              <div className="mt-3 grid sm:grid-cols-2 gap-3">
                <Toggle
                  label="Tickets Available"
                  checked={!!t.isTicketAvailable}
                  onChange={(v) => onArrayChange("ticketCategories", i, "isTicketAvailable", v)}
                />
              </div>

              <div className="mt-4">
                <Label>Perks</Label>
                {t.perks.map((perk, j) => (
                  <div key={j} className="mb-2 flex items-center gap-2">
                    <input
                      className={cn("min-w-0 flex-1", baseInput)}
                      value={perk}
                      onChange={(e) => {
                        const updated = [...t.perks];
                        updated[j] = e.target.value;
                        onArrayChange("ticketCategories", i, "perks", updated);
                      }}
                      placeholder="Add a perk…"
                      disabled={disabled}
                    />
                    <IconButton aria="Remove perk" onClick={() => {
                      const updated = t.perks.filter((_, idx) => idx !== j);
                      onArrayChange("ticketCategories", i, "perks", updated);
                    }}>
                      <FaTrash />
                    </IconButton>
                  </div>
                ))}
                <GhostButton onClick={() => onArrayChange("ticketCategories", i, "perks", [...t.perks, ""])}>
                  <FaPlus /> Add Perk
                </GhostButton>
              </div>

              <div className="mt-3">
                <DangerLink onClick={() => removeArrayItem("ticketCategories", i)}>
                  <FaTrash /> Remove Ticket
                </DangerLink>
              </div>
            </div>
          );
        })}

        <PrimaryButton
          type="button"
          className="mt-2"
          onClick={() =>
            addArrayItem("ticketCategories", {
              type: "",
              price: "",
              currency: "INR",
              totalSeats: "",
              availableSeats: "",
              perks: [""],
              isTicketAvailable: true, // NEW
            })
          }
        >
          <FaPlus /> Add Ticket
        </PrimaryButton>
      </Section>

      <Section title="GST" hint="Enter GST details for the event.">
        <div className="flex items-center gap-2 mb-2">
          {/* GST */}
          <input
            type="number"
            step="any"
            placeholder="Enter GST Rate (e.g. 18)"
            value={form.gstRate != null ? form.gstRate * 100 : ""}
            onChange={(e) => onFormChange("gstRate", e.target.value)}
            className="border p-2 w-full rounded-md"
          />

          {/* Conveniences Fee Type */}
          <select
            value={form.conveniencesFeeType}   // <-- यह सही है
            onChange={(e) => onFormChange("conveniencesFeeType", e.target.value)}
            className="border p-2 rounded-md w-30"
          >
            <option value="convenienceFeeFlat">Conveniences Fee Flat</option>
            <option value="convenienceFeePercent">Conveniences Fee Percentage</option>
          </select>

          <input
            type="number"
            step="any"
            placeholder={
              form.conveniencesFeeType === "convenienceFeePercent"
                ? "Enter % (e.g. 10)"
                : "Enter amount (e.g. 50)"
            }
            value={
              form.conveniencesFeeType === "convenienceFeePercent"
                ? form.convenienceFeePercent        // <-- Correct
                : form.convenienceFeeFlat           // <-- Correct
            }
            onChange={(e) =>
              onFormChange(
                form.conveniencesFeeType === "convenienceFeePercent"
                  ? "convenienceFeePercent"
                  : "convenienceFeeFlat",
                e.target.value
              )
            }
            className="border p-2 w-full rounded-md"
          />
          {/* convenienceFeePercent */}

        </div>
      </Section>

      {/* SHOWTIMES */}
      <Section
        title="Showtimes"
        subtitle="Add one or more schedules with pricing"
      >
        {form.showtimes.map((s, i) => (
          <div key={i} className="border p-4 my-2 rounded-2xl bg-white shadow-sm hover:shadow-md transition">
            <div className={AD.formGrid2}>
              <Input label="Start Time" type="datetime-local" value={s.startTime} onChange={(v) => onArrayChange("showtimes", i, "startTime", v)} />
              <Input label="End Time" type="datetime-local" value={s.endTime} onChange={(v) => onArrayChange("showtimes", i, "endTime", v)} />
              <Input label="Available Seats" type="number" value={s.availableSeats} onChange={(v) => onArrayChange("showtimes", i, "availableSeats", v)} />
              <Input label="Ticket Price" type="number" value={s.ticketPrice} onChange={(v) => onArrayChange("showtimes", i, "ticketPrice", v)} />
            </div>
            <div className="mt-3">
              <DangerLink onClick={() => removeArrayItem("showtimes", i)}>
                <FaTrash /> Remove Showtime
              </DangerLink>
            </div>
          </div>
        ))}

        <PrimaryButton
          type="button"
          onClick={() =>
            addArrayItem("showtimes", {
              startTime: "",
              endTime: "",
              availableSeats: "",
              ticketPrice: "",
            })
          }
        >
          <FaPlus /> Add Showtime
        </PrimaryButton>
      </Section>

      {/* IMAGES */}
      <Section
        title="Images"
        subtitle="Poster and landscape gallery"
      >
        {/* Poster */}
        <div>
          <Label>Poster Image</Label>
          <div className="border-2 border-dashed rounded-2xl p-4 text-center bg-white">
            <input type="file" accept="image/*" className="hidden" id="poster-upload" onChange={handlePosterFile} />
            <label htmlFor="poster-upload" className="cursor-pointer text-amber-700 hover:underline">
              {uploadProgress["poster"] ? <span className="inline-flex items-center gap-2"><FaSpinner className="animate-spin" /> Uploading…</span> : "Choose or drag a poster image"}
            </label>
            {uploadProgress["poster"] ? (
              <div className="mt-3 h-1.5 rounded bg-slate-100">
                <div className="h-1.5 rounded bg-amber-400" style={{ width: `${uploadProgress["poster"]}%` }} />
              </div>
            ) : null}
          </div>
          {form.imageUrl && <Thumb src={form.imageUrl} alt="Poster Preview" large />}
        </div>

        {/* Landscape */}
        <div className="mt-4">
          <Label>Landscape Images</Label>
          {form.landsacpImage.map((img, i) => (
            <div key={i} className="mb-3">
              <UploadRow
                inputId={`landscape-upload-${i}`}
                onFile={(e) => handleLandscapeFile(e, i)}
                progress={uploadProgress[`landscape-${i}`]}
                value={img}
                onChange={(v) => {
                  const imgs = [...form.landsacpImage];
                  imgs[i] = v;
                  onChange("landsacpImage", imgs);
                }}
              />
              <div className="mt-2 flex items-center gap-2">
                <IconButton aria="Remove image" onClick={() => removeArrayItem("landsacpImage", i)}>
                  <FaTrash />
                </IconButton>
                {img && <Thumb src={img} alt={`Landscape ${i + 1}`} />}
              </div>
            </div>
          ))}
          <GhostButton onClick={() => onChange("landsacpImage", [...form.landsacpImage, ""])}>
            <FaPlus /> Add Landscape Image
          </GhostButton>
        </div>
      </Section>

      {/* LAYOUT / SEATING PLAN */}
      <Section title="Layout / Seating Plan" subtitle="Upload a hall/ground layout image (optional)">
        <UploadRow
          inputId="layout-image-upload"
          onFile={handleLayoutImageFile}
          progress={uploadProgress["layout"]}
          value={form.layoutImage}
          onChange={(v) => onChange("layoutImage", v)}
          placeholder="Paste layout image URL (optional)"
        />
        {form.layoutImage && <Thumb src={form.layoutImage} alt="Layout Image" />}
      </Section>

      {/* ORGANIZER */}
      <Section
        title="Organizer"
        subtitle="Public information for event host"
      >
        <div className={AD.formGrid2}>
          {Object.keys(form.organizer)
            .filter((k) => k !== "logoUrl")
            .map((k) => (
              <Input
                key={k}
                label={k.charAt(0).toUpperCase() + k.slice(1)}
                value={form.organizer[k]}
                onChange={(v) => onNestedChange("organizer", k, v)}
                type={k === "contactEmail" ? "email" : k === "contactPhone" ? "tel" : "text"}
              />
            ))}
        </div>

        <div className="mt-2">
          <Label>Organizer Logo</Label>
          <UploadRow
            inputId="organizer-logo-upload"
            onFile={handleOrganizerLogoFile}
            progress={uploadProgress["organizer"]}
            value={form.organizer.logoUrl}
            onChange={(v) => onNestedChange("organizer", "logoUrl", v)}
          />
          {form.organizer.logoUrl && <Thumb src={form.organizer.logoUrl} alt="Organizer Logo" />}
        </div>
      </Section>

      {/* SPONSORS */}
      <Section
        title="Sponsors"
        subtitle="Show appreciation and manage branding"
      >
        {form.sponsors.map((s, i) => (
          <div key={i} className="border p-4 my-2 rounded-2xl bg-white shadow-sm hover:shadow-md transition">
            <div className={AD.formGrid2}>
              <Input label="Name" value={s.name} onChange={(v) => onArrayChange("sponsors", i, "name", v)} />
              <Select
                label="Type"
                value={s.type}
                options={[
                  "Title Sponsor", "Presenting Sponsor", "Powered By Sponsor", "Associate Sponsor", "Official Partner",
                  "Official Beverage Partner", "Official Food Partner", "Official Travel Partner", "Official Airline Partner",
                  "Official Transport Partner", "Official Hotel Partner", "Official Hospitality Partner", "Official Bank Partner",
                  "Official Insurance Partner", "Official Payment Partner", "Official Apparel Partner", "Official Footwear Partner",
                  "Official Merchandise Partner", "Official Electronics Partner", "Official Technology Partner", "Official Streaming Partner",
                  "Official Ticketing Partner", "Official Education Partner", "Official Telecom Partner", "Venue Partner", "Logistics Partner",
                  "Stage & Equipment Partner", "Printing Partner", "Security Partner", "Decoration Partner", "Photography Partner",
                  "Medical Partner", "Gifts Partner", "Print Media Partner", "TV Media Partner", "Radio Partner", "Digital Media Partner",
                  "Outdoor Media Partner", "Social Media Partner", "Accommodation Partner", "Catering Partner", "Food & Beverage Partner",
                  "Lounge Partner", "App Partner", "WiFi Partner", "Virtual Event Partner", "AR/VR Partner", "Gaming Partner",
                  "NGO Partner", "Environmental Partner", "Government Partner", "Cultural Partner"
                ]}
                onChange={(v) => onArrayChange("sponsors", i, "type", v)}
              />
            </div>

            <Textarea label="Description" value={s.description} onChange={(v) => onArrayChange("sponsors", i, "description", v)} />

            <div className="mt-2">
              <Label>Logo</Label>
              <UploadRow
                inputId={`sponsor-logo-upload-${i}`}
                onFile={(e) => handleSponsorLogoFile(e, i)}
                progress={uploadProgress[`sponsor-${i}`]}
                value={s.logo}
                onChange={(v) => onArrayChange("sponsors", i, "logo", v)}
              />
              {s.logo && <Thumb src={s.logo} alt={`Sponsor ${i + 1} logo`} />}
            </div>

            <div className="mt-3">
              <DangerLink onClick={() => removeArrayItem("sponsors", i)}>
                <FaTrash /> Remove Sponsor
              </DangerLink>
            </div>
          </div>
        ))}

        <PrimaryButton
          type="button"
          onClick={() =>
            addArrayItem("sponsors", {
              name: "",
              logo: "",
              description: "",
              type: "Title Sponsor",
            })
          }
        >
          <FaPlus /> Add Sponsor
        </PrimaryButton>
      </Section>

      {/* TERMS */}
      <Section title="Terms & Conditions" subtitle="Add points visible on the event page">
        {form.termsAndConditions.map((t, i) => (
          <div key={i} className="mb-2 flex items-center gap-2">
            <input
              className={cn("min-w-0 flex-1", baseInput)}
              placeholder="Write a point…"
              value={t.point}
              onChange={(e) => onArrayChange("termsAndConditions", i, "point", e.target.value)}
            />
            <IconButton aria="Remove term" onClick={() => removeArrayItem("termsAndConditions", i)}>
              <FaTrash />
            </IconButton>
          </div>
        ))}
        <GhostButton onClick={() => addArrayItem("termsAndConditions", { point: "" })}>
          <FaPlus /> Add Point
        </GhostButton>
      </Section>

      {/* TAGS */}
      <Section title="Tags" subtitle="Improve discoverability with keywords">
        {form.tags.map((tag, i) => (
          <div key={i} className="mb-2 flex items-center gap-2">
            <input
              className={cn("min-w-0 flex-1", baseInput)}
              placeholder="Add a tag…"
              value={tag}
              onChange={(e) => {
                const updated = [...form.tags];
                updated[i] = e.target.value;
                onChange("tags", updated);
              }}
            />
            <IconButton aria="Remove tag" onClick={() => removeArrayItem("tags", i)}>
              <FaTrash />
            </IconButton>
          </div>
        ))}
        <GhostButton onClick={() => onChange("tags", [...form.tags, ""])}>
          <FaPlus /> Add Tag
        </GhostButton>
      </Section>

      {/* OTHER */}
      <Section title="Other Details" subtitle="Operational details and flags">
        <div className={AD.formGrid2}>
          <Select label="Status" value={form.status} onChange={(v) => onChange("status", v)} options={["Upcoming", "Live", "Ended", "Cancelled", "Past"]} />
          <Input label="Remark" value={form.remark} onChange={(v) => onChange("remark", v)} />
          <Input label="Age Restriction" type="number" value={form.ageRestriction} onChange={(v) => onChange("ageRestriction", v)} />
          <Input label="Duration (minutes)" type="number" value={form.duration} onChange={(v) => onChange("duration", v)} />
          <Input label="Average Rating" type="number" step="0.1" min="0" max="5" value={form.ratings.averageRating} onChange={(v) => onNestedChange("ratings", "averageRating", v)} />
          <Input label="Total Reviews" type="number" min="0" value={form.ratings.totalReviews} onChange={(v) => onNestedChange("ratings", "totalReviews", v)} />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4">
          <Toggle label="Premium" checked={form.isVerified} onChange={(v) => onChange("isVerified", v)} />
          <Toggle label="Booking Open" checked={form.isBookingOpen} onChange={(v) => onChange("isBookingOpen", v)} />
          <Toggle label="Active" checked={form.isActived} onChange={(v) => onChange("isActived", v)} />
        </div>
      </Section>

      {/* footer actions */}
      <div className="flex items-center justify-end gap-2 pt-2">
        <Link
          to={`/admin/events/view/${id}`}
          className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-slate-700 hover:bg-slate-50"
        >
          <FaPlus className="opacity-70" />
          Back to View
        </Link>
        <PrimaryButton type="submit" disabled={loading}>
          {loading ? <><FaSpinner className="animate-spin" /> Updating…</> : "Update Event"}
        </PrimaryButton>
      </div>
    </form>
  );
}

/* ================= Address Picker (search + use my location) ================= */

function AddressPicker({ value, onPick }) {
  const [q, setQ] = useState(value?.address || "");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const debounced = useDebouncedValue(q, 300);
  const boxRef = useRef(null);

  useEffect(() => {
    setQ(value?.address || "");
  }, [value?.address]);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!debounced || debounced.trim().length < 3) {
        setResults([]);
        return;
      }
      setLoading(true);
      try {
        const arr = await nominatimSearch(debounced, { limit: 6 });
        if (!alive) return;
        setResults(arr || []);
        setOpen(true);
      } catch (e) {
        console.error(e);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [debounced]);

  useEffect(() => {
    const onClick = (e) => {
      if (!boxRef.current) return;
      if (!boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const handlePick = (osm) => {
    const patch = normalizeAddress(osm);
    onPick?.(patch);
    setQ(patch.address || "");
    setOpen(false);
  };

  const useMyLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported.");
      return;
    }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const { latitude, longitude } = pos.coords;
          const osm = await nominatimReverse(latitude, longitude);
          const patch = normalizeAddress(osm);
          onPick?.(patch);
          setQ(patch.address || "");
        } catch (e) {
          console.error(e);
          alert("Failed to reverse geocode location.");
        } finally {
          setLoading(false);
          setOpen(false);
        }
      },
      (err) => {
        console.error(err);
        setLoading(false);
        alert("Could not access your location.");
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  return (
    <div className="relative" ref={boxRef}>
      <Label>Find Address</Label>
      <div className="mt-1 flex gap-2">
        <div className="relative flex-1">
          <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            className="pl-9 pr-3 py-2.5 w-full rounded-xl border focus:ring-2 focus:ring-amber-300"
            placeholder="Search place, venue, street…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onFocus={() => results.length && setOpen(true)}
          />
          {loading && (
            <FaSpinner className="absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-slate-400" />
          )}
        </div>

        <button
          type="button"
          onClick={useMyLocation}
          className="inline-flex items-center gap-2 rounded-xl border px-3 py-2.5 text-sm font-semibold hover:bg-slate-50"
          title="Use my current location"
        >
          <FaCrosshairs /> Use my location
        </button>
      </div>

      {open && results.length > 0 && (
        <div className="absolute z-20 mt-1 w-full rounded-xl border bg-white shadow-lg max-h-64 overflow-auto">
          {results.map((r) => (
            <button
              type="button"
              key={`${r.place_id}-${r.lat}-${r.lon}`}
              onClick={() => handlePick(r)}
              className="w-full text-left px-3 py-2 hover:bg-amber-50"
            >
              <div className="flex items-start gap-2">
                <FaMapMarkerAlt className="mt-1 text-amber-600" />
                <div>
                  <div className="font-semibold text-slate-800">
                    {r.display_name?.split(",")?.[0] || "Place"}
                  </div>
                  <div className="text-xs text-slate-600 truncate">{r.display_name}</div>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

/* =========================================================
   Reusable UI — polished components
========================================================= */

const Section = ({ title, children, subtitle, icon }) => (
  <div className={cn(AD.formSurface, "transition-shadow hover:shadow-md")}>
    <div className="mb-4 flex items-start gap-3">
      {icon ? <div className="mt-0.5 text-amber-500">{icon}</div> : null}
      <div>
        <h2 className="text-base font-bold tracking-tight text-slate-900 dark:text-white">{title}</h2>
        {subtitle && <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">{subtitle}</p>}
      </div>
    </div>
    <div className="space-y-4">{children}</div>
  </div>
);

const Label = ({ children }) => <label className={AD.fieldLabel}>{children}</label>;

const baseInput = AD.inputField;

const Input = ({
  label,
  value,
  onChange,
  type = "text",
  required = false,
  placeholder,
  hint,
  step,
  min,
  max,
  disabled,
  field,
}) => (
  <div>
    {label && <Label>{label}</Label>}
    <input
      type={type}
      data-admin-field={field || undefined}
      className={cn("mt-1", baseInput, disabled && "cursor-not-allowed bg-slate-100 opacity-80 dark:bg-gray-900")}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      placeholder={placeholder}
      step={step}
      min={min}
      max={max}
      aria-label={label}
      disabled={disabled}
    />
    {hint && <p className={AD.fieldHint}>{hint}</p>}
  </div>
);

const Textarea = ({ label, value, onChange, rows = 4, placeholder, field }) => (
  <div>
    {label && <Label>{label}</Label>}
    <textarea
      data-admin-field={field || undefined}
      className={cn("mt-1", AD.textareaField, "min-h-[120px]")}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      rows={rows}
      placeholder={placeholder}
      aria-label={label}
    />
  </div>
);

const Select = ({ label, value, onChange, options, disabled, field }) => (
  <div>
    {label && <Label>{label}</Label>}
    <div className="relative mt-1">
      <select
        data-admin-field={field || undefined}
        className={cn(AD.select, disabled && "cursor-not-allowed bg-slate-100 opacity-80 dark:bg-gray-900")}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={label}
        disabled={disabled}
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
      <svg
        className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-slate-400"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M6 9l6 6 6-6" />
      </svg>
    </div>
  </div>
);

/* Buttons */

const PrimaryButton = ({ children, className = "", ...props }) => (
  <button className={cn(AD.btnPrimary, className)} {...props}>
    {children}
  </button>
);

const GhostButton = ({ children, className = "", ...props }) => (
  <button
    type="button"
    className={`inline-flex items-center gap-2 text-amber-700 hover:underline text-sm ${className}`}
    {...props}
  >
    {children}
  </button>
);

const DangerLink = ({ children, className = "", ...props }) => (
  <button
    type="button"
    className={`inline-flex items-center gap-2 text-red-600 hover:underline text-sm ${className}`}
    {...props}
  >
    {children}
  </button>
);

const IconButton = ({ children, aria, className = "", ...props }) => (
  <button
    type="button"
    aria-label={aria}
    className={`inline-flex h-10 w-10 items-center justify-center rounded-lg border bg-white text-slate-600 hover:bg-slate-50 ${className}`}
    {...props}
  >
    {children}
  </button>
);

/* Toggle */

const Toggle = ({ checked, onChange, label }) => (
  <label className={cn(AD.toggleRow, "cursor-pointer py-2.5")}>
    <span className="text-sm font-medium text-slate-800">{label}</span>
    <button
      type="button"
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${checked ? "bg-emerald-500" : "bg-slate-300"}`}
      aria-pressed={checked}
    >
      <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${checked ? "translate-x-5" : "translate-x-1"}`} />
    </button>
  </label>
);

/* Upload */

const UploadRow = ({ inputId, onFile, progress, value, onChange, placeholder = "Paste image URL (optional)" }) => (
  <div className="flex flex-col gap-2 md:flex-row">
    <input
      className={cn("min-w-0 md:flex-1", baseInput)}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
    <div className="border-2 border-dashed rounded-xl p-2 text-center">
      <input type="file" accept="image/*" className="hidden" id={inputId} onChange={onFile} />
      <label htmlFor={inputId} className="cursor-pointer text-amber-700 hover:underline">
        Choose or drag file
      </label>
    </div>
    {typeof progress === "number" ? (
      <div className="min-w-[140px] self-center text-xs text-slate-500">
        {progress < 100 ? "Uploading…" : "Done"}
        <div className="mt-1 h-1.5 rounded bg-slate-100">
          <div className="h-1.5 rounded bg-amber-400" style={{ width: `${progress}%` }} />
        </div>
      </div>
    ) : null}
  </div>
);

const Thumb = ({ src, alt = "Preview", large = false }) => (
  <div className="mt-3 flex items-center gap-3">
    <img
      src={src}
      alt={alt}
      className={`${large ? "h-40 w-40" : "h-16 w-16"} rounded-xl border object-cover`}
      onError={(e) => imgErrorFallback(e, 150, 150, "Image")}
    />
    <p className="break-all text-xs text-slate-500">{src}</p>
  </div>
);
